/* zChat 개발자 API 정의 문서 URL : https://api.zopim.com/web-sdk/#39-error-39-event */
var hideChatbotWidget = false; //PJTCHATBOT-4 add

$(document).ready(function() {

    var epromoterStarEnable = true;

    var btnSendable = true; //중복 보내기 방지
    var loadedWidget = false;
    var socketClosed = false;
    var lastScrollTop = 0;
    var autoScrollStop = false;
    var conversationEnd = false;
    var waitingTimeoutIns = null;
    var waitingTimeout180Ins = null;
    var waitingTimeout360Ins = null;
    var headerTimeoutToggleIns = null;
    var headerTimeoutToggle = 3;
    var queueCountLimit = 0;
    var chatbotCloseMsg = 'lg-chatbot-close';
    var startEscapeChar = '[[[click submit btn]]]';
    var departmentRegexp = /^LGEPRO_KR_/gi;
    var departmentVideoRegexp = /^LGEPRO_KR_VIDEO/gi;
    var snapCallUrlRegexp = /snapcall.io/gi;
    var linkInfoUrlRegexp = /lg.com/gi;
    var star = 2;
    var tempForReqRating = null;
    var alertTimeout = 2;
    var waitingTimeout = 5;
    var waitTimeoutSec180 = 99999; //원안은 180초였으나 안나오게 해달라고 하여 99999초로 함.
    var waitTimeoutSec360 = 99999; //원안은 180초였으나 안나오게 해달라고 하여 99999초로 함.
    var limitedFileSize = 1024 * 1024 * 20;
    var allowedFileExt = ['pdf', 'txt', 'png', 'jpeg', 'jpg', 'gif'];
    var channelType = ['chat', 'video'];
    var globalDepartmentId = 0;
    //var emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var emailRegexp = /^[0-9a-zA-Z]([+-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    var selectedData = {'maindepth':[0, 0, '', '', 0], 'subdepth':[0, 0, '', '', 0], 'chattype':[0, 0, '', '', 0], 'waiting':[0, 0, '', '', 0], 'mkt':[0, 0, '', '', 0], 'email':[0, 0, '', '', 0]};
    //사용되는 Tag들 endchat 시 removetags를 해서 초기화를 해주어야 한다. 안해주면 기존 쳇에서 설정된 Tag들이 남아있게 된다.
    var tagsArr = [ 'marketing_disagree','marketing_agree','chatrating_good','chatrating_bad','chatrating_','chatrating_0','chatrating_1','chatrating_2','chatrating_3','chatrating_4','chatrating_5','pp_agree','pp_agree_save'];
    var showroomCount = 0;
    //ajax로 국가별로 설정된 언어나 설정값들을 가져옴.
    var config = {};

    var appkey = '';
    //setZChatInstanceInit();
    
    var chatbotOfflineChangeFlag = false; // LGEMS-394
    
    function setZChatValInit()
        {
            autoScrollStop = false;
            conversationEnd = false;
            star = 2;
            //별점 클릭 가능하도록 해제.
            epromoterStarEnable = true;
            globalDepartmentId = 0;
            selectedData = {'maindepth':[0, 0, '', '', 0], 'subdepth':[0, 0, '', '', 0], 'chattype':[0, 0, '', '', 0], 'waiting':[0, 0, '', '', 0], 'mkt':[0, 0, '', '', 0], 'email':[0, 0, '', '', 0]};
            showroomCount = 0;
            tempForReqRating = null;
            $('input[name=epromotorppChk]').removeAttr('disabled');
            if(config.localeCode == 'PH')   $('#epromotorPhone, #epromotorMessage').removeAttr('disabled');	// LGEPH-308 add
            $('#epromotorChatTextarea').removeAttr('disabled', true);
            $('#epromotorChatTextarea').val('');
            $('#epromotorTextArea').prop('disabled', true);
            $('#epromotorTextArea').val('');
            $('#epromotorSendFile').prop('disabled', true);
            $('.epromotor-star__range').removeAttr('disabled');
            $('.epromotor-star__range').val(0);
            $('#epromotorReqRatingSubmit').prop('disabled',true);

            //LGCOMMON-5306 START
            if(config.fullNameUseFlag == 'Y'){
            	$('#epromotorUserFullName,#epromotorUserEmail').removeAttr('disabled');
            }else{
            	$('#epromotorUserFirstName,#epromotorUserLastName,#epromotorUserEmail').removeAttr('disabled');
            	$('#epromotorUserFirstName').val(config.loginFname);
                $('#epromotorUserLastName').val(config.loginLname);
            }
            //LGCOMMON-5306 END
            
            $('#epromotorUserEmail').val(config.loginEmail);

            try{ clearTimeout(waitingTimeoutIns); }catch(e){}finally{}
            try{ clearInterval(headerTimeoutToggleIns); }catch(e){}finally{}
            try{ clearTimeout(waitingTimeout180Ins); }catch(e){}finally{}
            try{ clearTimeout(waitingTimeout360Ins); }catch(e){}finally{}
        }

    function setZChatUnixToTime(timestamp)
      {
        var t = timestamp;
        var date = new Date(t);

        var hours = date.getHours();
        var minutes = date.getMinutes();

        var ampm = hours >= 12 ? 'pm' : 'am';
        var timeSeperate = ':';

        //프랑스 시간 포멧
        if( $.inArray(config.localeCode.toLowerCase(), ['fr']) !== -1 )
            {
                ampm = '';
                minutes = minutes < 10 ? '0' + minutes : minutes;
                timeSeperate = 'h';
            }
        else
            {
                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
            }

        return hours + timeSeperate + minutes + ' ' + ampm;
      }

    function getZChatTrasUnit(file_size)
        {
            var _file_size = file_size
            var kb = 1024;
            var mb = 1024 * 1024;

            if( _file_size < kb )
                {
                    return (parseFloat(_file_size)).toFixed(2).toString() + 'B';
                }
            else if( _file_size >= kb && _file_size < mb )
                {
                    return ( parseFloat(_file_size) / kb ).toFixed(2).toString() + 'KB';
                }
            else if( _file_size >= mb )
                {
                    return ( parseFloat(_file_size) / mb ).toFixed(2).toString() + 'MB';
                }
            else
                {
                    return 'Unknown';
                }
        }

    function getZChatUnixTime()
        {
            return Math.floor(new Date().getTime());
        }

    function getChkCookieValidation(key)
        {
            return typeof($.cookie(key)) === 'undefined' ? false : true;
        }

    function zChatEvtHandler(event_data)
        {
            //console.log(event_data);

            if( typeof(event_data) != 'object'){ return; }

            //console.log(event_data);

            switch(event_data.type)
              {
                case 'chat.msg':
                    setZChatLine(event_data, (event_data.nick == 'visitor' ? 'customer' : 'agent'));
                    break;
                case 'chat.file':
                    setZChatFileLine(event_data);
                    break;
                case 'chat.queue_position':
                    setZChatAgentStatus();
                    break;
                case 'chat.wait_queue':
                    //console.log(event_data);
                    break;
                case 'chat.memberjoin':
                    if( event_data.nick != 'visitor' )
                        {
                            try{ clearTimeout(waitingTimeoutIns); }catch(e){}
                            try{ clearInterval(headerTimeoutToggleIns); }catch(e){}

                            $(document).find('.epromotor-bottom').addClass('epromotor-bottom--active');

                            $('#epromotorSendFile').removeAttr('disabled');

                            $('#epromotorTextArea').removeAttr('disabled');

                            $('#epromotorTextArea').val().length > 0 ? $('.epromotor-container .epromotor-btn.epromotor-btn--send').removeAttr('disabled') : '';
                            //새탭/ 새로고침 개인정보 submit 후 대기 상태와 연결 상태 대응

                            if( getChkCookieValidation('zchatdata') )
                                {
                                    var temp = getZChatCookieParse('zchatdata');
                                    if( temp.waiting[2] !== '' && temp.waiting[0] > 0)
                                        {
                                            setZChatWaitingCmt(true, event_data);
                                            setZChatAgentStartLine(event_data);
                                        }
                                    else //개인정보 submit 시 구워진 쿠키로 인해.
                                        {
                                            setZChatAgentStartLine(event_data);
                                        }
                                }
                            else
                                {
                                    setZChatAgentStartLine(event_data);
                                }

                            $('#epromotorSendFile').removeAttr('disabled');
                      }
                  break;
                case 'chat.memberleave':
                    //setZChatEndChatProc();
                    //setZChatInitProc();
                    //$('.epromotor-chat-dom').remove();
                    //$('.epromotor-contents__inner').scrollTop(0);
                    $('.epromotor-contents__inner').scrollTop($('.epromotor-contents__inner').prop('scrollHeight'));
                    break;
                case 'chat.request.rating':
                    //별점왔을 때 타임아웃 클리어
                    try{ clearTimeout(waitingTimeoutIns); }catch(e){}
                    try{ clearInterval(headerTimeoutToggleIns); }catch(e){}
                    try{ clearTimeout(waitingTimeout180Ins); }catch(e){}
                    try{ clearTimeout(waitingTimeout360Ins); }catch(e){}

                    $(document).find('.epromotor-bottom').removeClass('epromotor-bottom--active');

                    autoScrollStop = false;
                    setZChatAgentEndLine(event_data);
                    setZChatLine({'msg':config.endChat,'timestamp':event_data.timestamp}, 'agent');
                    //setZChatMktBtn(event_data);
                    setZChatSendEmailBtn(event_data);
                    //setZChatReqRating(event_data);
                    setZChatMktBtn(event_data);
                    conversationEnd = true;
                    break;
                case 'chat.rating':
                    setZChatStarRatingForm(event_data);
                    break;
                case 'chat.comment':
                    setZChatCommentForm(event_data);
                    break;
                case 'typing':
                    setZChatLoading(event_data.typing);
                    break;
                case 'last_read':
                    //console.log(event_data);
                    break;
                default:
                    break;
              }
            return;
        }

    function setZChatScrollTop()
        {
            if( autoScrollStop )
                {
                    return setZChatBottomAlert('new', config.newMsg, true);
                }
            //linkinfo DOM 생성 시 비동기로 인해 scrolltop이 부정확하여 delay를 줌.
            setTimeout(function(){
                $('.epromotor-contents__inner').scrollTop($('.epromotor-contents__inner').prop('scrollHeight'));
                lastScrollTop = $('.epromotor-contents__inner').scrollTop();
            },10);
            return;
            //return $('.epromotor-contents__inner').scrollTop($('.epromotor-contents__inner').prop('scrollHeight'));
        }

    function setZChatLayer()
        {
            var accStatus = getZChatFilterAgentStatus();
            var $html;

            if( accStatus == 'online')
                {
                    $(document).find('.epromotor-chat').addClass('epromotor-chat--ready epromotor-chat--active');
                    //$(document).find('.epromotor-bottom').addClass('epromotor-bottom--active');
                    $(document).find('.epromotor-support').removeClass('epromotor-support--ready epromotor-support--active');
                    $('#epromotorOffline').hide();
                }
            else
                {
                    if( getZChatEditLog().length > 0)
                        {
                            $(document).find('.epromotor-chat').addClass('epromotor-chat--ready epromotor-chat--active');
                            $(document).find('.epromotor-bottom').addClass('epromotor-bottom--active');
                            $(document).find('.epromotor-support').removeClass('epromotor-support--ready epromotor-support--active');
                            $('#epromotorOffline').hide();
                        }
                    else
                        {
                            $(document).find('.epromotor-chat').removeClass('epromotor-chat--ready epromotor-chat--active');
                            $(document).find('.epromotor-bottom').removeClass('epromotor-bottom--active');
                            $(document).find('.epromotor-support').addClass('epromotor-support--ready epromotor-support--active');
                            $('#epromotorOffline').show();
                        }
                }
            return;
        }

    function setZChatSupportHtml()
        {
    		// LGEMS-394 
    		if( config.chatbotSupportHtmlFlag == "Y"){
    			var html = '';
    			//LGCOMNL-133 Start
    			if(config.localeCode == 'NL' &&  getZChatDepartemntsWorkingHour() == 'Y'){
    				html =  '<div class="epromotor-chat__string-head">'+
			                    config.epromoterNlWorktimeHeader +
			                  '</div>'+
			                  '<div class="epromotor-chat__string-body">';

			          html += config.epromoterNlWorktimeLine1 == 'N' ? '' : config.epromoterNlWorktimeLine1 + '<br /><br />';
			          html += config.epromoterNlWorktimeLine2 == 'N' ? '' : config.epromoterNlWorktimeLine2 + '<br /><br />';
			
			          html +=     '<div class="epromotor-chat__btn-area">'+
			                          '<a href="'+config.sendEmailUrl+'" class="epromotor-btn epromotor-btn--base" target="_blank">'+
			                          config.btnSendMail +
			                          '</a>'+
			                      '</div>'+
			                  '</div>';
    			}else{
		            html =  '<div class="epromotor-chat__string-head">'+
		                      config.noWorktimeHeader +
		                    '</div>'+
		                    '<div class="epromotor-chat__string-body">';
		
		            html += config.worktimeLine1 == 'N' ? '' : config.worktimeLine1 + '<br /><br />';
		            html += config.worktimeLine2 == 'N' ? '' : '<strong>' + config.worktimeLine2 + '</strong><br />';
		            html += config.worktimeLine3 == 'N' ? '' : config.worktimeLine3 + '<br /><br />';
		            html += config.worktimeLine4 == 'N' ? '' : '<strong>' + config.worktimeLine4 + '</strong><br />';
		            html += config.worktimeLine5 == 'N' ? '' : config.worktimeLine5 + '<br /><br />';
		            html += config.worktimeLine6 == 'N' ? '' : config.worktimeLine6 ;
		
		            html +=     '<div class="epromotor-chat__btn-area">'+
		                            '<a href="'+config.sendEmailUrl+'" class="epromotor-btn epromotor-btn--base" target="_blank">'+
		                            config.btnSendMail +
		                            '</a>'+
		                        '</div>'+
		                    '</div>';
    			}
	            $('#epromoterSupportDiv').html(html);
    		}
        }
	/* LGESE-118 start*/
	function setZChatSupportSaleHtml()
	    {
	        var html = '';
	        if(config.saleMessageFlag=='Y'){
	        	html = '<div class="epromotor-chat__string-head">';
	        	html += config.saleMessage1 == 'N' ? '' : config.saleMessage1 + '<br /><br />';
	        	html += config.saleMessage2 == 'N' ? '' : config.saleMessage2 + '<br /><br />';
	        	html += config.saleMessage3 == 'N' ? '' : config.saleMessage3;
                html += config.saleMessage4 == 'epromoter-lang-sale-message4' ? '' : '<p class="sale-desc">' + config.saleMessage4 + '</p>'; // LGESE-158
	        	html +=     '<div class="epromotor-chat__btn-area">'+
				                '<a href="'+config.sendSaleUrl+'" class="epromotor-btn epromotor-btn--base" target="_blank">'+
				                config.btnSendSale +
				                '</a>'+
				            '</div>'+
				        '</div>';
	        	$('#epromoterSupportSaleDiv').html(html);
	        }
        
        
	    }
	    /* LGESE-118 end*/
    function setZChatSendEmailBtn(chat)
        {
            var html = '';
            var txt = '';
            var btnDisable = '';
            var temp = getZChatCookieParse('zchatdata');

            if( getChkCookieValidation('zchatdata') )
                {
                    if( temp.email[2] !== '' )
                        {
                            btnDisable = ' disabled';
                        }
                }

            html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat-dom epromotor-reqrating-dom">'+
                      '<div class="epromotor-chat__string epromotor-form" id="epromoterEmailYesNoForm">'+
                        '<div class="epromotor-chat__string-head">'+
                          config.sendEmail +
                        '</div>'+
                        '<div class="epromotor-chat__string-body">'+
                          '<p class="epromotor-btn-group epromotor-btn-group--row">'+
                            '<button type="button" class="epromotor-btn epromotor-btn--base" id="epromoterEmailYesBtn" ' + btnDisable + '>'+
                              config.btnYes +
                            '</button>'+
                            '<button type="button" class="epromotor-btn epromotor-btn--gray epromotor-btn--color-white" id="epromoterEmailNoBtn" ' + btnDisable + '>'+
                              config.btnNo +
                            '</button>'+
                          '</p>'+
                        '</div>'+
                      '</div>'+
                      '<span class="epromotor-chat__time">'+
                        setZChatUnixToTime(chat.timestamp) +
                      '</span>'+
                    '</div>';

            setAppendChatLine(html, 'after', false);

            if( getChkCookieValidation('zchatdata') )
                {
                    if( temp.email[2] !== '' )
                        {
                            setZChatLine({'msg':(temp.email[3].toLowerCase() == 'yes' ? config.btnYes : config.btnNo),'timestamp':temp.email[2]}, 'customer');
                            setZChatReqRating(chat);
                        }
                }

            setZChatScrollTop();

            var visitorInfo = zChat.getVisitorInfo();

            $('#epromoterEmailYesBtn').on('click', function(){
                setZChatBottomAlert('normal', config.sendEmailAlert.replace('{0}', '"' + visitorInfo.email + '"'), true);
                $('#epromoterEmailYesNoForm').addClass('epromotor-form--disabled');
                $this = $(this);
                zChat.sendEmailTranscript(visitorInfo.email, function(err){
                    var temp = getZChatCookieParse('zchatdata');
                    temp.email[2] = setZChatUnixToTime(getZChatUnixTime());
                    temp.email[3] = 'Yes';
                    setZChatCookie(temp, 'zchatdata', 'json');
                    setZChatLine({'msg':config.btnYes,'timestamp':temp.email[2]}, 'customer');
                    setZChatReqRating(chat);
                    $this.parent().find('button').prop('disabled', true);
                    setZChatScrollTop();
                });
            });

            $('#epromoterEmailNoBtn').on('click', function(){
                $('#epromoterEmailYesNoForm').addClass('epromotor-form--disabled');
                var temp = getZChatCookieParse('zchatdata');
                temp.email[2] = setZChatUnixToTime(getZChatUnixTime());
                temp.email[3] = 'No';
                setZChatCookie(temp, 'zchatdata', 'json');
                setZChatLine({'msg':config.btnNo,'timestamp':temp.email[2]}, 'customer');
                setZChatReqRating(chat);
                $(this).parent().find('button').prop('disabled', true);
                setZChatScrollTop();
            });

            return;
        }

    function setZChatMktBtn(chat)
        {
            var html = '';
            var rated = false;
            var checked = '';
            var btnDisable = '';
            var txt = '';
            var temp = getZChatCookieParse('zchatdata');

            if( getChkCookieValidation('zchatproclog') )
                {
                    temp = getZChatCookieParse('zchatproclog');
                    if( !isNaN(parseInt(temp.star)) )
                        {
                            rated = true;
                        }
                }

            temp = getZChatCookieParse('zchatdata');

            if( getChkCookieValidation('zchatdata') )
                {
                    var chkArr = $.cookie('zchatppchk').split(',');
                    checked = chkArr.indexOf('2') === -1 ? '' : ' checked="checked"';
                    if( temp.mkt[2] !== '' )
                        {
                            btnDisable = ' disabled';
                        }
                }

            if( checked === '' && rated )
                {
                    html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat-dom epromotor-reqrating-dom">'+
                          '<div class="epromotor-chat__string epromotor-form" id="epromoterMktYesNoForm">'+
                            '<div class="epromotor-chat__string-head">'+
                              config.reMkt+
                            '</div>'+
                            '<div class="epromotor-chat__string-body">'+
                              '<p class="epromotor-form__item" style="margin-bottom: 18px;">'+
                                  '<span class="epromotor-form__label-inner">'+
                                    config.ppMktAgree +
                                  '</span>'+
                              '</p>'+
                              '<p class="epromotor-btn-group epromotor-btn-group--row">'+
                                '<button type="button" class="epromotor-btn epromotor-btn--base" id="epromoterMktYesBtn" ' + btnDisable + ' data-val="yes">'+
                                  config.btnYes +
                                '</button>'+
                                '<button type="button" class="epromotor-btn epromotor-btn--gray epromotor-btn--color-white" id="epromoterMktNoBtn" ' + btnDisable + ' data-val="no">'+
                                  config.btnNo +
                                '</button>'+
                              '</p>'+
                            '</div>'+
                          '</div>'+
                          '<span class="epromotor-chat__time">'+
                            setZChatUnixToTime(chat.timestamp) +
                          '</span>'+
                        '</div>';

                    setAppendChatLine(html, 'after', 'epromotorStarRatingForm');
                }

            if( getChkCookieValidation('zchatdata') )
                {
                    if( checked )
                        {
                            setZChatRestartButton(chat.timestamp);
                        }
                    else
                        {
                            if( temp.mkt[2] !== '' )
                                {
                                    setZChatLine({'msg':(temp.mkt[3].toLowerCase() == 'yes' ? config.btnYes : config.btnNo),'timestamp':temp.mkt[2]}, 'customer');
                                    //setZChatSendEmailBtn(chat);
                                    setZChatRestartButton(chat.timestamp);
                                }
                        }
                }

            setZChatScrollTop();

            $('#epromoterMktYesBtn,#epromoterMktNoBtn').on('click', function(){
                var addTagRating = [];
                txt = $(this).text();
                var dataVal = $(this).attr('data-val');

                $(this).parent().find('button').prop('disabled', true);
                $('#epromoterMktYesNoForm').addClass('epromotor-form--disabled');

                dataVal == 'yes' ? addTagRating.push('marketing_agree') : addTagRating.push('marketing_disagree');

                zChat.removeTags(['marketing_disagree', 'marketing_agree'], function(err) {
                zChat.addTags(addTagRating, function(err) {
                    if( !err )
                        {
                            if( getChkCookieValidation('zchatdata') )
                                {
                                    var chkArr = $.cookie('zchatppchk').split(',');
                                    if( dataVal == 'yes' && chkArr.indexOf('2') === -1 && addTagRating.indexOf('marketing_agree') !== -1 )
                                        {
                                            chkArr.push(2);
                                            setZChatCookie(chkArr.join(','), 'zchatppchk', 'string');
                                        }
                                }

                            setZChatLine({'msg':txt,'timestamp':chat.timestamp}, 'customer');

                            if( getChkCookieValidation('zchatdata') )
                                {
                                    var temp = getZChatCookieParse('zchatdata');
                                    temp.mkt[2] = setZChatUnixToTime(getZChatUnixTime());
                                    temp.mkt[3] = dataVal;
                                    setZChatCookie(temp, 'zchatdata', 'json');
                                    //setZChatSendEmailBtn(chat);
                                    setZChatRestartButton(chat.timestamp);
                                }
                        }
                    });
                });
            });

            return;
        }

    function setZChatParsingUrlForLinkInfo(chat)
        {
            var _chat = chat;
            return (_chat.msg).match(linkInfoUrlRegexp) ? true : false;
        }

    function setZChatParsingUrlForSnapCall(chat)
        {
            var _chat = chat;
            return (_chat.msg).match(snapCallUrlRegexp) ? true : false;
        }

    function setZChatLine(chat, sender, id)
        {
            var _chat = chat;
            var html = '', videoUrl='';

            //escape start message charactor
            if( _chat.msg == startEscapeChar ){return;}

            if( setZChatParsingUrlForSnapCall(_chat) )
                {
                    return setZChatChatFuncButton(['video'], _chat.msg);
                }

            if( setZChatParsingUrlForLinkInfo(_chat) )
                {
                    var $returnHtml = setZChatLinkInfoDummy(sender);
                    return getZChatLinkInfo(_chat.msg, $returnHtml, _chat.timestamp);
                }

            if( _chat.msg == '[unsupported message type]' ){
                if( typeof(_chat.structured_msg.buttons[0]) !== 'undefined' ){
                    videoUrl = _chat.structured_msg.buttons[0].action.value;

                    //아래 조건은 cac_en(파나마) showroom과 일반 video call을 구분할 수 없으므로 무조건 맨 처음만 버튼에 config.btnSelectionShowroom 문구를 붙이기 위해서임.
                    if( showroomCount < 1 && channelType.indexOf('showroom') !== -1){
                        setZChatChatFuncButton(['takeshowroom'], videoUrl);
                        showroomCount++;
                        return;
                    }else{
                        return setZChatChatFuncButton(['video'], videoUrl);
                    }
                }
            }

            var time = typeof( _chat.timestamp ) === 'string' ? _chat.timestamp: setZChatUnixToTime(_chat.timestamp);

            switch(sender)
                {
                    case 'agent':
                        html =  '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat-dom">'+
                                    '<div class="epromotor-chat__string">'+
                                      _chat.msg.replace(/\n/g, '<br/>') +
                                    '</div>'+
                                    '<span class="epromotor-chat__time">'+
                                      time +
                                    '</span>'+
                                '</div>';
                        break;
                    case 'customer':
                        html = '<div class="epromotor-chat__message epromotor-chat__message--sent epromotor-chat__message--etc-group epromotor-chat-dom">'+
                                  '<div class=" epromotor-chat__string">'+
                                    _chat.msg.replace(/\n/g, '<br/>') +
                                  '</div>'+
                                  '<span class="epromotor-chat__time">'+
                                    time +
                                  '</span>'+
                              '</div>';
                        break;
                    default:
                    break;
                }

            setAppendChatLine(html, 'after', typeof(id) !== 'undefined' ? id : false);
            setZChatScrollTop();
            return;
        }

    function setZChatReturnLine(chat)
        {
            var _chat = chat;
            var html = '';

            html =  '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat-dom">'+
                      '<div class="epromotor-chat__string">'+
                        _chat.msg.replace(/\n/g, '<br/>') +
                      '</div>'+
                      '<span class="epromotor-chat__time">'+
                        _chat.time +
                      '</span>'+
                    '</div>';
            return html;
        }

    function setZChatAgentStartLine(chat)
        {
            var _chat = chat;
            var html = '';
            html = '<div class="epromotor-date epromotor-date--thick epromotor-chat-dom">'+
                      '<b>' + config.connectedAgency + '  </b><span class="epromotor-date__time">' + setZChatUnixToTime(_chat.timestamp) + '</span>'
                    '</div>';
            setAppendChatLine(html, 'after', false);
            var temp = getZChatCookieParse('zchatdata');
            temp.waiting[0] = 1; //연결 대기 후 연결됨.
            setZChatCookie(temp, 'zchatdata', 'json');
            setZChatWelcomeCmt(true, _chat);
            setZChatScrollTop();
            return;
        }

    function setZChatAgentEndLine(chat)
        {
            var _chat = chat;
            var headerTxt = $('#epromotorAccountStatusTxt');
            var headerLamp = $('#epromotorAccountStatus');
            var html = '';
            html = '<div class="epromotor-date epromotor-date--thick epromotor-chat-dom">'+
                      '<b>' + config.endChatTime + ' </b><span class="epromotor-date__time">' + setZChatUnixToTime(_chat.timestamp) + '</span>'
                    '</div>';
            setAppendChatLine(html, 'after', false);
            $('#epromotorTextArea').prop('disabled', true);
            $('.epromotor-container .epromotor-btn.epromotor-btn--send').prop('disabled', true);
            $('#epromotorSendFile').prop('disabled', true);

            headerTxt.text(' ' + config.postChat);
            headerLamp.removeClass('epromotor-header--live');

            setZChatScrollTop();
            return;
        }

    function setZChatWelcomeCmt(b, chat)
        {
            var _b = b;
            var _chat = chat;
            var html = '';
            var time = setZChatUnixToTime(_chat.timestamp);

            if( _b )
                {
                    var agencyGreetingStr = config.agencyGreeting.replace('{0}', _chat.display_name);

                    html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat-dom epromotor-chat__message--bgmotion" id="epromotorWelcomeComment">'+
                                '<div class="epromotor-chat__string">'+
                                    agencyGreetingStr +
                                '</div>'+
                                '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+
                                    time +
                                '</span>'+
                            '</div>';
                    setAppendChatLine(html, 'after', false);
                    setZChatTimeCookie(time);
                }
            else
                {
                    $('#epromotorWelcomeComment').remove();
                }
            return;
        }

    function setZChatWaitingCmt(connected, chat)
        {
            var queueCount = zChat.getQueuePosition();
            //if( queueCount <= queueCountLimit && !connected ){ return; }
            var html = '';
            var startTime = typeof(chat) !== 'object' ? setZChatUnixToTime(getZChatUnixTime()) : setZChatUnixToTime(chat.timestamp);

            html =  '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat-dom" id="epromotorWaitingComment">'+
                      '<div class="epromotor-chat__string">'+
                      config.sorryWait +
                      '</div>'+
                      '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+
                      startTime +
                      '</span>'+
                    '</div>';

            html += '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--etc-group epromotor-chat-dom" id="epromoterWaitingBtn" style="display:none;">'+
                      '<div class="epromotor-btn-group">'+
                        '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorWaiting">'+
                          config.btnWait +
                        '</button>'+
                        '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorWaitingEmail">'+
                          config.btnNoWait +
                        '</button>'+
                      '</div>'+
                    '</div>';

            setAppendChatLine(html, 'after', false);
            setZChatTimeCookie(startTime);

            //새탭/새로고침 시 대응
            if( getChkCookieValidation('zchatdata') )
                {
                    var temp = getZChatCookieParse('zchatdata');
                    if( temp.waiting[2] !== '' )
                        {
                            if( temp.waiting[1] < 1 )
                                {
                                    setZChatSelectedBtn(temp.waiting, 'epromotorWaitingComment');
                                    setZChatLine({'msg':config.thanksWait, 'timestamp':temp.waiting[2]}, 'agent');
                                }
                            else
                                {
                                    setZChatSelectedEmailBtn(config.btnNoWait, 'epromoterWaitingBtn', 'epromoterTrackingBtn');
                                    setZChatWaitingRestartButton(temp.waiting[1]);
                                }
                        }
                    else //개인정보 submit 시 구워진 쿠키로 인해.
                        {
                            $('#epromoterWaitingBtn').show();
                        }
                }
            else
                {
                    $('#epromoterWaitingBtn').show();
                }

            setZChatScrollTop();

            $('#epromotorWaiting').on('click', function(){
                setZChatSelectedBtn($(this).text(), 'epromoterWaitingBtn', 'epromoterTrackingBtn');
                var timestamp = getZChatUnixTime();
                var time = setZChatUnixToTime(timestamp);
                var temp = getZChatCookieParse('zchatdata');
                temp.waiting[2] = time;
                temp.waiting[3] = escape($(this).text());

                setZChatCookie(temp, 'zchatdata', 'json');
                setZChatLine({'msg':config.thanksWait, 'timestamp':timestamp}, 'agent', 'epromoterTrackingBtn');
                $('#epromoterWaitingBtn').remove();
            });
            $('#epromotorWaitingEmail').on('click', function(){
                setZChatSelectedEmailBtn($(this).text(), 'epromoterWaitingBtn', 'epromoterTrackingBtn');
                var timestamp = getZChatUnixTime();
                var time = setZChatUnixToTime(timestamp);
                var temp = getZChatCookieParse('zchatdata');
                temp.waiting[1] = timestamp; //이메일 버튼 구분
                temp.waiting[2] = time;
                temp.waiting[3] = escape($(this).text());

                setZChatWaitingRestartButton(timestamp);

                setZChatCookie(temp, 'zchatdata', 'json');
                $('#epromoterWaitingBtn').remove();
                setZChatScrollTop();

                window.open(config.sendEmailUrl);
            });
            return;
        }

    function setZChatBeforeConn(time)
        {
            var html = '';
            var _time = time;

            var visitorInfo = zChat.getVisitorInfo();

            var preconnectStr = config.preconnect.replace('{0}', visitorInfo.display_name);

            html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat-dom" id="epromotorWelcomeComment">'+
                        '<div class="epromotor-chat__string">'+
                            preconnectStr +
                        '</div>'+
                        '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+
                            _time +
                        '</span>'+
                    '</div>';

            setAppendChatLine(html, 'after', 'epromotorPrivacyPolicyForm');

            return;
        }

    function setZChatWaitingRestartButton(timestamp)
        {
            var html = '';
            html =  '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--etc-group epromotor-chat-dom">'+
                        '<div class="epromotor-btn-group">'+
                            '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorRestartBtn">'+
                                config.btnRestart +
                            '</button>'+
                        '</div>'+
                        '<span class="epromotor-chat__time">'+
                            setZChatUnixToTime(timestamp) +
                        '</span>'+
                    '</div>';

            setAppendChatLine(html, 'after', false);
            setZChatScrollTop();

            $('#epromotorRestartBtn').on('click', function(){
                setZChatEndChatProc();
                zChat.removeTags(tagsArr, function(err) { });
            });

            return;
        }
    function setZChatChangeAccountStatusCmt()
        {
            var html = '';
            //LGCOMNL-133 Start
			if(config.localeCode == 'NL' &&  getZChatDepartemntsWorkingHour() == 'Y'){
	            html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--single epromotor-chat-dom" id="epromoterChatDomDiv">'+
                '<div class="epromotor-chat__string epromotor-chat__string--contents">'+
                  '<div class="epromotor-chat__string-head">'+
                  config.epromoterNlWorktimeHeader +
                  '</div>'+
                  '<div class="epromotor-chat__string-body">';

	          html += config.epromoterNlWorktimeLine1 == 'N' ? '' : config.epromoterNlWorktimeLine1 + '<br /><br />';
	          html += config.epromoterNlWorktimeLine2 == 'N' ? '' : config.epromoterNlWorktimeLine2 + '<br /><br />';
	
	          html +=     '<div class="epromotor-chat__btn-area">'+
			              '<a href="'+config.sendEmailUrl+'" class="epromotor-btn epromotor-btn--base" target="_blank">'+
			                config.btnSendMail +
			              '</a>'+
			            '</div>'+
			          '</div>'+
			        '</div>'+
			      '</div>';
		    }else{
	            html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--single epromotor-chat-dom" id="epromoterChatDomDiv">'+
	                    '<div class="epromotor-chat__string epromotor-chat__string--contents">'+
	                      '<div class="epromotor-chat__string-head">'+
	                        config.overWorktimeHeader +
	                      '</div>'+
	                      '<div class="epromotor-chat__string-body">';
	
	            html += config.worktimeLine1 == 'N' ? '' : config.worktimeLine1 + '<br /><br />';
	            html += config.worktimeLine2 == 'N' ? '' : '<strong>' + config.worktimeLine2 + '</strong><br />';
	            html += config.worktimeLine3 == 'N' ? '' : config.worktimeLine3 + '<br /><br />';
	            html += config.worktimeLine4 == 'N' ? '' : '<strong>' + config.worktimeLine4 + '</strong><br />';
	            html += config.worktimeLine5 == 'N' ? '' : config.worktimeLine5 + '<br /><br />';
	            html += config.worktimeLine6 == 'N' ? '' : config.worktimeLine6 ;
	
	            html +=     '<div class="epromotor-chat__btn-area">'+
	                          '<a href="'+config.sendEmailUrl+'" class="epromotor-btn epromotor-btn--base" target="_blank">'+
	                            config.btnSendMail +
	                          '</a>'+
	                        '</div>'+
	                      '</div>'+
	                    '</div>'+
	                  '</div>';
		    }
     		  //LGCOMNL-133 End
            setAppendChatLine(html, 'after', false);
            setZChatScrollTop();
        }

    function setZChatRestartButton(timestamp)
        {
            var html = '';
            html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--etc-group epromotor-chat-dom">'+
                      '<div class="epromotor-btn-group">'+
                        '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorRestartBtn">'+
                          config.btnRestart +
                        '</button>'+
                      '</div>'+
                      '<span class="epromotor-chat__time">'+
                        setZChatUnixToTime(timestamp) +
                      '</span>'+
                    '</div>';

            if( getChkCookieValidation('zchatproclog') )
                {
                    var temp = getZChatCookieParse('zchatproclog');
                    if( !isNaN(parseInt(temp.star)) )
                        {
                            setZChatLine({'msg':config.feedbackEnd, 'timestamp':timestamp}, 'agent');
                            setAppendChatLine(html, 'after', false);
                        }
                }

            setZChatScrollTop();

            $('#epromotorRestartBtn').on('click', function(){
                setZChatEndChatProc();
                zChat.removeTags(tagsArr, function(err) { });
            });

            return;
        }

    function setZChatChatFuncButton(btn_arr, link)
      {
        if( btn_arr.length < 1 ){ return; }

        var html = '', btnHtml='';
        var btnArrLen = btn_arr.length;
        var btnTempArr = [];

        for( var i = 0; i < btnArrLen; i++ )
            {
                btnHtml = '';
                if( btn_arr[i].indexOf('video') !== -1 )
                    {
                        btnHtml = '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorCommTypeVideo" data-video-url="'+link+'">'+
                                    config.btnSelectionVideo +
                                '</button>';
                    }
                if( btn_arr[i].indexOf('showroom') !== -1 )
                    {
                        btnHtml = '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorCommTypeShowRoom">'+
                                    config.btnSelectionShowroom +
                                '</button>';
                    }
                if( btn_arr[i].indexOf('takeshowroom') !== -1 )
                    {
                        btnHtml = '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorCommTypeTakeShowRoom" data-video-url="'+link+'">'+
                                    config.btnTrsShowroom +
                                '</button>';
                    }
                if( btn_arr[i].indexOf('chat') !== -1 )
                    {
                        btnHtml = '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotorCommTypeChat">'+
                                    config.btnSelectionChat +
                                  '</button>';
                    }
                if( btn_arr[i].indexOf('download') !== -1 )
                    {
                        btnHtml = '<a href="#" class="epromotor-btn epromotor-btn--bubble" id="epromotorCommTypeDownload">'+
                                    'Chat Download'+
                                  '</a>';
                    }
                if( btn_arr[i].indexOf('email') !== -1 )
                    {
                        btnHtml = '<a href="#" class="epromotor-btn epromotor-btn--bubble" id="epromotorCommTypeEmail">'+
                                    config.btnSendMail +
                                  '</a>';
                    }

                btnTempArr.push(btnHtml);
            }

        html = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--etc-group epromotor-chat-dom" id="epromotorCommType">'+
                  '<div class="epromotor-btn-group">'+
                    btnTempArr.join('') +
                  '</div>'+
                '</div>';

        typeof(link) == 'boolean' && !link ? setAppendChatLine(html, 'before', 'epromotorPrivacyPolicyForm') : setAppendChatLine(html, 'after', false);

        var visitorInfo = zChat.getVisitorInfo();

        if( btn_arr.indexOf('video') !== -1 )
            {
                $("#epromotorCommTypeVideo").on('click', function(){
                    selectedData.chattype[2] = setZChatUnixToTime(getZChatUnixTime());
                    selectedData.chattype[3] = escape($(this).text());
                    if( $(this).attr('data-video-url') ){
                        window.open( $(this).attr('data-video-url') );
                    }
                });
            }
        if( btn_arr.indexOf('showroom') !== -1 )
            {
                $("#epromotorCommTypeShowRoom").on('click', function(){
                    //showroom video department(prefix:LGEPRO_{country_code}_video)가 별도로 있다하여 설정.
                    var allGroupArr = zChat.getAllDepartments();

                    $.each(allGroupArr, function(idx, item){
                        if( item.name.match(departmentVideoRegexp) ){ globalDepartmentId = item.id; }
                    });

                    selectedData.chattype[2] = setZChatUnixToTime(getZChatUnixTime());
                    selectedData.chattype[3] = escape($(this).text());
                    setZChatSelectedBtn(config.btnSelectionShowroom, 'epromotorCommType');
                    $('#epromotorCommType').remove();
                    $('#epromotorPrivacyPolicyForm').show();
                    //setZChatScrollTop();
                    $('.epromotor-contents__inner').scrollTop(300);
                    //LGCOMMON-5306 START
                    if(config.fullNameUseFlag == 'Y'){
                    	$('#epromotorUserFullName').focus();
                    }else{
                    	$('#epromotorUserFirstName').focus();
                    }
                    //LGCOMMON-5306 END
                });
            }
        if( btn_arr.indexOf('takeshowroom') !== -1 )
            {
                $("#epromotorCommTypeTakeShowRoom").on('click', function(){
                    if( $(this).attr('data-video-url') ){
                        window.open( $(this).attr('data-video-url') );
                    }
                    setZChatScrollTop();
                });
            }
        if( btn_arr.indexOf('chat') !== -1 )
            {
                $("#epromotorCommTypeChat").on('click', function(){
                    selectedData.chattype[2] = setZChatUnixToTime(getZChatUnixTime());
                    selectedData.chattype[3] = escape($(this).text());
                    setZChatSelectedBtn(config.btnSelectionChat, 'epromotorCommType');
                    $('#epromotorCommType').remove();
                    $('#epromotorPrivacyPolicyForm').show();
                    //setZChatScrollTop();
                    $('.epromotor-contents__inner').scrollTop(300);
                    //LGCOMMON-5306 START
                    if(config.fullNameUseFlag == 'Y'){
                    	$('#epromotorUserFullName').focus();
                    }else{
                    	$('#epromotorUserFirstName').focus();
                    }
                    //LGCOMMON-5306 END
                });
            }
        if( btn_arr.indexOf('download') !== -1 )
            {
                $("#epromotorCommTypeDownload").on('click', function(){
                    selectedData.chattype[2] = setZChatUnixToTime(getZChatUnixTime());
                    selectedData.chattype[3] = escape($(this).text());
                });
            }
        if( btn_arr.indexOf('email') !== -1 )
            {
                $("#epromotorCommTypeEmail").on('click', function(){
                    selectedData.chattype[2] = setZChatUnixToTime(getZChatUnixTime());
                    selectedData.chattype[3] = escape($(this).text());
                    setZChatBottomAlert('normal', config.sendEmailAlert.replace('{0}', '"' + visitorInfo.email + '"'), true);
                    zChat.sendEmailTranscript(visitorInfo.email, function(err){ });
                });
            }
        //setZChatScrollTop();
      }
    function setZChatLinkInfoDummy(sender)
        {
            var senderClass = sender == 'customer' ? 'sent epromotor-chat__message--etc-group' : 'receive';
            html =  '<div class="epromotor-chat__message epromotor-chat__message--'+senderClass+' epromotor-chat-dom" style="display:none;">'+
                  '</div>';

            var $html = $(html);
            $html.appendTo('.epromotor-container .epromotor-chat');
            return $html;
        }
    //LGCOMITF-176 Start
    function convertUrlsToLinks(text,fontColorClass) {
    	text = text.replace(/\n/g, ' <br>');
        const urlPattern = /(https:\/\/(www\.)?lg\.com[^\s]*)/gi;
        return text.replace(urlPattern,'<a href="$1" class="' + fontColorClass + '" target="_blank">$1</a>');
    }
    //LGCOMITF-176 End    
    function setZChatLinkInfo(data, html_obj, timestamp)
        {
            var html='',imgUrl='',reviewCount='',fontColorClass = '';
            var $html_obj = html_obj;
            var $html;

            if( data.image !== '' )
                {
                    var urlArr = data.url.split('/');
                    imgUrl = urlArr.length > 2 ? urlArr[0] + '//' + urlArr[2] + data.image : '';
                    reviewCount = data.reviewCount !== '' ? '('+data.reviewCount+')': '';
                }

            //제품링크가 아닐 경우 시 링크를 노출
            if( data.image == null || data.image == '' )
                {
                    fontColorClass = $html_obj.hasClass('epromotor-chat__message--sent') ? 'epromotor-btn--color-white' : '';
                    $html_obj.removeAttr('style');
                    html =  '<div class="epromotor-chat__string">'+
                    		convertUrlsToLinks(data.url,fontColorClass) +				//LGCOMITF-176
                            '</div>'+
                            '<span class="epromotor-chat__time">'+
                                setZChatUnixToTime(timestamp) +
                            '</span>';
                    $html = $(html);
                    $html.appendTo($html_obj);

                    setZChatScrollTop();

                    return;
                }

            html =  '<div class="epromotor-chat-product">'+
                        '<span class="epromotor-chat-product__image">'+
                            '<img src="'+imgUrl+'" width="214" alt="">'+
                        '</span>'+
                        '<div class="epromotor-chat-product__info">'+
                            '<strong class="epromotor-chat-product__name">'+data.name+'</strong>'+
                            '<em class="epromotor-chat-product__model">'+data.sku+'</em>'+
                            '<div class="grade">'+
                                '<span class="grade__star grade__star--'+data.bestRating+'"></span>'+
                                '<span class="grade__counter">'+
                                    data.ratingValue+
                                '</span>'+
                                '<span class="grade__participants">'+
                                    reviewCount+
                                '</span>'+
                            '</div>'+
                            '<div class="epromotor-chat-product__price">'+
                                '<strong>'+
                                    data.purchasePriceUnit + '' + data.purchasePriceNumber +
                                '</strong>'+
                                '<del>'+
                                    data.productPriceNumber +
                                '</del>'+
                                '<em>'+data.discount.replace('*discountMsg*','')+'</em>'+
                            '</div>'+
                            '<a href="'+data.url+'" class="epromotor-btn epromotor-btn--base" target="_blank">'+config.viewMore+'</a>'+
                        '</div>'+
                    '</div>';

            $html = $(html);
            $html.appendTo($html_obj);

            $html.find('img').on('load',function(){
                $html_obj.show();
                setZChatScrollTop();
            });
        }

    function setZChatLoading(b)
        {
            //b is boolean
            var _b = b;
            var loading = $('.epromotor-container .epromotor-loading');
            var html = '';
            if( _b )
               {
            	// LGEIN-825 Start : Preference 코드 적용하여 타 법인도 쉽게 적용가능하게 설정
            	if(config.agentTypingMessageFlag == 'Y') 
            		{
            		html = '<div class="epromotor-loading">'+
			        			'<span class="epromotor-loading__text">'+
			        				'<em>'+ config.agentTypingMessage +'</em>'+
			        			'</span>'
			        		'</div>';
            		} 
            	else 
            		{
            		html = '<div class="epromotor-loading">'+
                    			'<span class="epromotor-loading__dot">'+
                    				'<em>loading</em>'+
                    			'</span>'
                    		'</div>';
            		}
            	// LGEIN-825 End
            	setAppendChatLine(html, 'after', false);
                }
            else
                {
                    loading.remove();
                }
            //LGEIN-825 End
            setZChatScrollTop();
            return;
        }

    function setZChatBottomAlert(type, msg, b_timeout)
        {
            var typeArr = ['normal', 'error', 'new'];
            if( typeArr.indexOf(type) === -1 ){ return; }

            var _type = type;
            var _msg = msg;
            var _timeout = typeof(b_timeout) === 'boolean' && b_timeout === false ? 0 : alertTimeout;
            var html = '', addClass='';

            if( _type == 'new'){
                addClass = 'epromotor-bottom-alert--arrow';
            }else if( _type == 'error'){
                addClass = 'epromotor-bottom-alert--warning';
            }

            html =  '<div class="epromotor-bottom-alert ' + addClass + ' ready active">'+
                      '<p class="epromotor-bottom-alert__message">'+
                        _msg +
                      '</p>'+
                    '</div>';
            var $html = $(html);
            $html.prependTo('.epromotor-bottom__inner');

            if( _type === 'new' )
                {
                    $html.on('click', function(){
                        autoScrollStop = false;
                        setZChatScrollTop();
                    });
                }

            return _timeout > 0 ? setTimeout(function(){$html.remove();}, _timeout * 1000) : '';
        }

    function setZChatBottomAlertRemove()
        {
            return $('.epromotor-bottom-alert,.epromotor-bottom-error').remove();
        }

    function setZChatEndNoConfirm()
        {
            setZChatEndChatProc();
            zChat.removeTags(tagsArr, function(err) { });
            $('.epromotor-chat-area ').removeClass('ready active');
            $('.epromotor-widget-area').addClass('ready active');
        }

    function setZChatEndConfirm()
        {
            if( $('.epromotor-confirm-layer').length > 0 ){return;}
            var html = '';
            var $html;
            html = '<div class="epromotor-confirm-layer ready active">'+
                        '<div class="epromotor-confirm-layer__inner">'+
                            '<p class="epromotor-confirm-layer__contents">'+
                                config.alarmPopUp +
                            '</p>'+
                            '<p class="epromotor-btn-group epromotor-btn-group--row">'+
                                '<button type="button" class="epromotor-btn epromotor-btn--gray epromotor-btn--color-white" id="epromotorConfirmEndYes">'+
                                    config.btnYes +
                                '</button>'+
                                '<button type="button" class="epromotor-btn epromotor-btn--base" id="epromotorConfirmEndNo">'+
                                    config.btnNo+
                                '</button>'+
                            '</p>'+
                        '</div>'+
                    '</div>';

            $html = $(html);
            $html.prependTo('.epromotor-contents');

            $('#epromotorConfirmEndYes').on('click', function(){
                setZChatEndChatProc();
                zChat.removeTags(tagsArr, function(err) { });
                //$('.epromotor-confirm-layer').remove();
                $('.epromotor-chat-area ').removeClass('ready active');
                $('.epromotor-widget-area').addClass('ready active');
                if ($(".chat_drag").hasClass('ui-draggable')) {
                    $(".chat_drag").draggable("destroy");
                }
            });

            $('#epromotorConfirmEndNo').on('click', function(){
                $('.epromotor-confirm-layer').remove();
            });

            //setAppendChatLine(html, 'after', false);
        }

    function setZChatFileUploadExtAlert(b_timeout)
        {
            var _timeout = typeof(b_timeout) === 'boolean' && b_timeout === false ? 0 : alertTimeout;
            var html = '';

            html =  '<div class="epromotor-chat__message  epromotor-chat__message--sent epromotor-sendfile-alert-dom epromotor-chat-dom">'+
                        '<p class="epromotor-chat-alert">'+
                            '<img src="/lg5-common-gp/images/customer/ic-alert.svg" alt="">'+
                            config.fileExtAlert+
                        '</p>'+
                    '</div>';

            setAppendChatLine(html, 'after', false);

            setZChatScrollTop();

            return _timeout > 0 ? setTimeout(function(){$('.epromotor-sendfile-alert-dom').remove();}, _timeout * 1000) : '';
        }

    function setZChatFileUpLoadAlert()
        {
            var html ='';
            html = '<div class="epromotor-chat__message  epromotor-chat__message--sent epromotor-chat-dom">'+
                        '<p class="epromotor-chat-alert">'+
                            '<img src="/lg5-common-gp/images/customer/ic-alert.svg" alt="">'+
                            config.fileSizeAlert +
                        '</p>'+
                    '</div>';

            setAppendChatLine(html, 'after', false);

            return;
        }

    function setZChatFileLine(chat)
        {
            var _chat = chat;
            var html = '';

            var mimeType = _chat.attachment.mime_type;
            var fileSize = _chat.attachment.size;
            var fileName = _chat.attachment.name;
            var url = _chat.attachment.url;
            var timestamp = _chat.timestamp;

            var from = _chat.nick == 'visitor' ? 'sent' : 'receive'

            if( mimeType.indexOf('image') !== -1 )
              {
                html = '<div class="epromotor-chat__message epromotor-chat__message--' + from + ' epromotor-chat__message--etc-group epromotor-chat-dom" style="display:none;">'+
                          '<div class="epromotor-chat__image">'+
                            '<span class="epromotor-chat__image-inner">'+
                              '<img class="epromotor-attach-image" src="' + url + '" width="100%" alt="' + fileName + '">'+
                            '</span>'+
                          '</div>'+
                          '<span class="epromotor-chat__time">'+
                            setZChatUnixToTime(timestamp) +
                          '</span>'+
                        '</div>';
              }
            else
              {
                html = '<div class="epromotor-chat__message epromotor-chat__message--' + from + ' epromotor-chat-dom">'+
                          '<div class="epromotor-chat__file">'+
                            '<button type="button" class="epromotor-chat__download" data-url="' + url + '">'+
                              '<span class="epromotor-chat__download-text">'+
                                fileName +
                              '</span>'+
                              '<span class="epromotor-chat__download-volume">'+
                                '24.7KB'+
                              '</span>'+
                              '<span class="epromotor-chat__download-icon" aria-label="download state">'+
                                '<svg class="epromotor-chat__download-circle" width="36" height="36" viewBox="0 0 36 36">'+
                                  '<circle class="frame" cx="18" cy="18" r="17" stroke-width="1"/>'+
                                '</svg>'+
                                '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16"class="epromotor-chat__download-img">'+
                                  '<g fill="none" fill-rule="evenodd" stroke-linecap="round">'+
                                    '<g stroke="#707070">'+
                                      '<path d="M7.5 0L7.5 9.643" transform="translate(-265 -207) translate(0 83) translate(58 90) translate(198 25) translate(9 9) translate(1 1)"/>'+
                                      '<path stroke-linejoin="round" d="M3.571 7.143L7.223 10.794 10.874 7.143" transform="translate(-265 -207) translate(0 83) translate(58 90) translate(198 25) translate(9 9) translate(1 1)"/>'+
                                      '<path stroke-linejoin="round" d="M0 10L0 13.955 15 13.955 15 10" transform="translate(-265 -207) translate(0 83) translate(58 90) translate(198 25) translate(9 9) translate(1 1)"/>'+
                                    '</g>'+
                                  '</g>'+
                                '</svg>'+
                              '</span>'+
                            '</button>'+
                          '</div>'+
                          '<span class="epromotor-chat__time">'+
                            setZChatUnixToTime(timestamp) +
                          '</span>'+
                        '</div>';
              }

            var $html = $(html);
            $html.appendTo('.epromotor-container .epromotor-chat');

            if( mimeType.indexOf('image') !== -1 )
              {
                //image load 시간이 느려서 완료 이벤트가 발생하면 스크롤.
                $('.epromotor-attach-image').on('load',function(){
                  $html.show();
                  setZChatScrollTop();
                });
              }
            else
                {
                    var request = new XMLHttpRequest();
                    $html.find('.epromotor-chat__download').on('click', function(){
                        var fileUrl = $(this).attr('data-url');
                        var el = $(this).find('.epromotor-chat__download-circle');
                        el.css('stroke-dashoffset', 107);
                        $(this).addClass('epromotor-chat__download--active');

                        $.ajax({
                            url: fileUrl,
                            type : 'get',
                            xhrFields: { responseType: 'blob' },
                            xhr: function() {
                                var xhr = $.ajaxSettings.xhr();
                                xhr.onprogress = function(e) {
                                    if( Math.floor(e.loaded / e.total * 100) !== Infinity )
                                        {
                                            el.css('stroke-dashoffset', (107 - Math.floor(e.loaded / e.total * 100)));
                                        }
                                  };
                              return xhr;
                            },
                            success : function(data) {
                                el.css('stroke-dashoffset', 0); //파일이 작아서 onprogress 에서 문제가 생겼을 경우 프로그레스 써클이 완성이 안되는 문제로 인해 추가.
                                var blob = new Blob([data]);

                                if ( navigator.msSaveBlob )
                                    {
                                        return navigator.msSaveBlob(blob, fileUrl);
                                    }
                                else
                                    {
                                        var link = document.createElement('a');
                                        link.href = window.URL.createObjectURL(blob);
                                        link.download = fileName;
                                        link.click();
                                        setTimeout(function(){ window.URL.revokeObjectURL(fileUrl); }, 10000);
                                        return;
                                    }
                            }
                        });
                    });

                    $html.find('span.epromotor-chat__download-volume').text( getZChatTrasUnit(fileSize) );
                    //bottomCheck.update();
                    setZChatScrollTop();
                }
            return;
        }

    function setZChatReqRating(chat)
        {
            $('div[name=epromotorStarRatingForm]').appendTo('.epromotor-container .epromotor-chat');
            $('div[name=epromotorStarRatingForm]').show();
            $('#epromotorReqRatingTime').text(setZChatUnixToTime(chat.timestamp));
            //setZChatRestartButton(chat.timestamp);
            tempForReqRating = chat;
            setZChatScrollTop();
            return;
        }

    function setAppendChatLine(html, part, target_id)
        {
            var _html = html;
            var _target_id = target_id;

            if( part == 'after' )
                {
                    if( typeof(_target_id) == 'string' )
                        {
                            $(document).find('#'+ _target_id ).after(_html);
                        }
                    else
                        {
                            $(document).find('.epromotor-container .epromotor-chat').append(_html);
                        }
                }
            else if( part == 'before' )
                {
                    if( typeof(_target_id) == 'string' )
                        {
                            $(document).find('#'+ _target_id ).before(_html);
                        }
                    else
                        {
                            $(document).find('.epromotor-container .epromotor-chat').append(_html);
                        }
                }
            return;
        }
    function setZChatStarRatingForm(chat)
        {
            var _chat = chat;
            var temp = getZChatCookieParse('zchatproclog');
            if( _chat == null)
                {
                    $('div[name=epromotorStarRatingForm]').hide();
                    $('#epromotorStarUi').attr('data-star-value',0);
                    $('#epromotorReqRatingSubmit').attr('disabled',false);
                    $('#epromotorChatTextarea').attr('disabled',false);
                    //element에 event를 한번 줘야 정상동작함.
                    $('.epromotor-star__range').val(0);
                    $('#epromotorRateDesc').remove();
                }
            else
                {
                    if( typeof(temp) !== 'undefined' )
                        {
                            $.each($('.epromotor-star__item'), function(idx, item){
                                if( !isNaN(parseInt(temp.star))){
                                    if( idx < temp.star ){$(this).addClass('active');}
                                }
                            });
                            $('div[name=epromotorStarRatingForm] .epromotor-form').addClass('epromotor-form--disabled');
                            $('.epromotor-star__range').attr('disabled', true);
                            //별점을 submit 했으면 다시 못보내게 막음.
                            epromoterStarEnable = false;
                        }
                    $('#epromotorStarUi').attr('data-star-value',_chat.star);
                    $('#epromotorReqRatingSubmit').attr('disabled',true);
                    $('#epromotorChatTextarea').attr('disabled',true);
                    $('#epromotorRateDesc').remove();
                }

            return;
        }
    function setZChatCommentForm(chat)
        {
            var _chat = chat;
            $('#epromotorStarUi').attr('data-star-value',0);
            $('#epromotorReqRatingSubmit').attr('disabled',true);
            $('#epromotorChatTextarea').attr('disabled',true);
            $('#epromotorChatTextarea').val(_chat.new_comment);
            $('#epromotorRateDesc').remove();

            return;
        }

    function setZChatPPForm(b)
        {
            var _b = b;
            var visitorInfo = zChat.getVisitorInfo();
            var name;
            var checkboxArr = [];

            if( _b )
                {
                    $('#epromotorPrivacyPolicyForm .epromotor-form__alert').hide();
                    checkboxArr = $.cookie('zchatppchk').split(',');

                    if( checkboxArr.indexOf('0') !== -1 ){
                        $("input:checkbox[id='epromotorPrivacyPolicy']").attr("checked", true);
                        $("input:checkbox[id='epromotorPrivacyPolicy']").attr('disabled', true);
                    }
                    if( checkboxArr.indexOf('1') !== -1 && config.ppSaveAgreeUseFlag == 'Y'){ //LGCOMMON-5306
                        $("input:checkbox[id='epromotorChatHistory']").attr("checked", true);
                        $("input:checkbox[id='epromotorChatHistory']").attr('disabled', true);
                    }
                    if( checkboxArr.indexOf('2') !== -1 ){
                        $("input:checkbox[id='epromotorPromotionCheck']").attr("checked", true);
                        $("input:checkbox[id='epromotorPromotionCheck']").attr('disabled', true);
                    }

                    //$('.epromotor-btn.epromotor-btn--base.epromotor-policy-button').attr('disabled', true);
                    //LGCOMMON-5306 START
                    if(config.fullNameUseFlag == 'Y'){
                    	$('#epromotorUserFullName').val(visitorInfo.display_name);
                    }else{
                    	$('#epromotorUserFirstName').val(visitorInfo.display_name.split(' ')[0]);
                        $('#epromotorUserLastName').val(visitorInfo.display_name.split(' ')[1]);
                    }
                    //LGCOMMON-5306 END
                    $('#epromotorUserEmail').val(visitorInfo.email);
                    $('#epromotorUserName').attr('readonly', true);
                    $('#epromotorUserEmail').attr('readonly', true);
                    $('#epromotorPrivacyPolicyForm .epromotor-form').addClass('epromotor-form--disabled');
                }
            else
                {
                    $("#epromotorPrivacyPolicyForm input").prop("checked", false);
                    $('#epromotorUserName').val('');
                    $('#epromotorUserEmail').val('');
                    $('#epromotorUserName').removeAttr('readonly');
                    $('#epromotorUserEmail').removeAttr('readonly');
                    $('#epromotorPhone').val('');		// LGEPH-308 add
                    $('#epromotorMessage').val('');		// LGEPH-308 add
                }
            return;
        }

    function getZChatFilterAgentStatus()
        {
            var accStatus = zChat.getAccountStatus();
            var allGroupArr = zChat.getAllDepartments();
            var accStatusStr = '';
            var $newChatInfoArea = $('.gnb-newChatbotInfo');

            for(var i=0; i < allGroupArr.length; i++ ){
                if( allGroupArr[i].name.match(departmentRegexp) ){
                    if( allGroupArr[i].status == 'online'){
                        accStatusStr = 'online';
                        break;
                    }else{
                        accStatusStr = 'offline';
                    }
                }
            }
            
            
            if($newChatInfoArea.length > 0){
            	$newChatInfoArea.attr('data-chat-status', accStatusStr)
            	$newChatInfoArea.data('chatStatus', accStatusStr);
            }

            return accStatusStr;

        }

    function setZChatAgentStatus()
        {
            var queueCount = zChat.getQueuePosition();
            var accStatus = getZChatFilterAgentStatus();
            var headerTxt = $('#epromotorAccountStatusTxt');
            var headerLamp = $('#epromotorAccountStatus');
            var chatlog = zChat.isChatting() ? getZChatEditLog() : [];

            switch(accStatus)
                {
                    case 'online':
                        try{ clearTimeout(headerTimeoutToggleIns); }catch(e){}
                        if( chatlog.length > 0 )
                            {
                                if( queueCount < 1 )
                                    {
                                        if( conversationEnd && zChat.isChatting() )
                                            {
                                                headerTxt.text(' ' + config.postChat);
                                                headerLamp.removeClass('epromotor-header--live');
                                            }
                                        else
                                            {
                                                headerTxt.text(' ' + config.onlineNow);
                                                headerLamp.addClass('epromotor-header--live');
                                            }
                                    }
                                else if( queueCount > 0 )
                                    {
                                        var customerVoca = queueCount == 1 ? config.customerInQueue : config.customersInQueue;
                                        headerTxt.text(queueCount + ' ' + customerVoca);
                                        headerLamp.removeClass('epromotor-header--live');
                                        headerTimeoutToggleIns = setInterval(function(){
                                            headerTxt.text() == queueCount + ' ' + customerVoca ? headerTxt.text(' ' + config.preChat) : headerTxt.text( queueCount + ' ' + customerVoca );
                                        }, headerTimeoutToggle * 1000);
                                    }
                            }
                        else
                            {
                                headerTxt.text(' ' + config.preChat);
                                headerLamp.removeClass('epromotor-header--live');
                            }

                        break;
                    case 'offline':
                        if( !zChat.isChatting() )
                            {
                                headerTxt.text('');
                                headerLamp.removeClass('epromotor-header--live');
                                setZChatChangeAccountStatusCmt();
                                //LGCOMNL-133 Start
                                if(config.localeCode == 'NL'){
                                	setZChatSupportHtml();
                                }
                                //LGCOMNL-133 End
                            }
                        else
                            {
                                headerTxt.text(' ' + config.onlineNow);
                            }
                        break;
                    default:
                    break;
                }
            return;
        }
    function getZChatEditLog()
        {
            var chatLog = zChat.getChatLog();
            var filterChatLog = [];

            //zChat.getChatLog()는 zChat.endChat() 을 해도 기존 데이터가 남아 있으므로 편집.
            $.each(chatLog, function(idx, item){
                if( item.type == 'chat.memberleave' )
                    {
                        filterChatLog = [];
                    }
                else
                    {
                        filterChatLog.push(item);
                    }
            });

            //기다려달라는 자동 메세지 때문에 애매한 필터로 인해 추가.
            if( filterChatLog.length == 2 ){
                if( filterChatLog[1].nick == 'agent:trigger' ){
                    filterChatLog = [];
                }
            }

            return filterChatLog;
        }
    function setZChatInitProc()
        {
            btnSendable = true;
            var filterChatLog = getZChatEditLog();

            if( filterChatLog.length > 0 )
                {
                    setZChatBeforeConn( setZChatUnixToTime(getZChatUnixTime()) );
                    //$('input[name=epromotorppChk]').prop('disabled',true);
                    //LGCOMMON-5306 START
                    if(config.fullNameUseFlag == 'Y'){
                    	$('#epromotorUserFullName,#epromotorUserEmail').prop('disabled',true);
                    }else{
                    	$('#epromotorUserFirstName,#epromotorUserLastName,#epromotorUserEmail').prop('disabled',true);
                    }
                    //LGCOMMON-5306 END
                    if(config.localeCode == 'PH')   $('#epromotorPhone, #epromotorMessage').prop('disabled',true);	// LGEPH-308 add
                    $('.epromotor-chat-area ').addClass('ready active');
                    $('.epromotor-widget-area').removeClass('ready active');
                    if ($(".chat_drag").hasClass('ui-draggable') == false) {
                        $( ".chat_drag" ).draggable({ handle: ".chat_bar" , containment: "body"});
                    }
                    setZChatScrollTop();
                }

            $('.epromotor-container .epromotor-btn.epromotor-btn--send').prop('disabled', true);
            $('#epromotorChatTextarea').attr('disabled', true);

            if( zChat.isChatting() && !socketClosed ){
                $.each(filterChatLog, function(idx, item){ zChatEvtHandler(item); });
            }else{
                filterChatLog = [];
            }

            //비정상적인 종료로 인해 close가 안되었을 경우를 위해.
            //zChat.getChatLog()가 비어있다면 상담원과의 연결이 끊어진 경우임.
            try
                {
                    if( filterChatLog !== null )
                        {
                            if( filterChatLog.length < 1 )
                                {
                                    setZChatDelCookie(['zchatppchk', 'zchatproclog', 'zchatdata']);
                                    $('#epromotorPrivacyPolicyForm').hide(); //privacy policy form 숨김.
                                    $('.epromotor-form__alert').hide(); //입력폼 입력 안내 경고 숨김.
                                }
                        }
                }
            catch(e)
                {
                    setZChatDelCookie(['zchatppchk']);
                }

            if( getChkCookieValidation('zchatppchk') )
                {
                    setZChatPPForm(true);
                    if( getChkCookieValidation('zchatdata') )
                        {
                            var temp = getZChatCookieParse('zchatdata');

                            if( temp.waiting[0] < 1 )
                                {
                                    setZChatWaitingCmt(true);
                                }
                        }
                    else
                        {
                            setZChatWaitingCmt(true);
                        }
                }
            else
                {
                    setZChatPPForm(false);
                    setZChatWelcomeCmt(false, '');
                }

            setZChatTimeCookie('');
            setZChatAgentStatus();
            setZChatLayer();

            //새 탭 열기 혹은 새로고침 시 채팅 중이라면 파일 선택 버튼 비활성화 해제.
            // agent가 memberjoin 해야 비활성화 해제.
            if( !conversationEnd && filterChatLog.length > 2)
                {
                    $('#epromotorSendFile').removeAttr('disabled');
                }

            return filterChatLog.length;
        }

    function setZChatEndChatProc()
        {
            var clearDeptId = { clear_dept_id_on_chat_ended: true };
            var visitorInfo = { display_name : 'visitor', email : '' };
            try{
                zChat.endChat(clearDeptId, function (err) {
                    zChat.setVisitorInfo(visitorInfo, function(err) { if(!err){ }});
                    zChat.clearVisitorDefaultDepartment(function(err) { if(!err){ }});

                    setZChatDelCookie(['zchatppchk', 'zchatdata']);
                    $('.epromotor-chat-dom').remove();
                    $('.epromotor-category-dom').remove();
                    $('#epromotorMainCategory').remove();
                    $('#epromotorSubCategory').remove();
                    // LGEMS-378
                    $('#epromoter-select-chat-btn').remove();
                    $('#epromoter-select-chat-msg').remove();
                    setZChatInitProc();
                    setZChatStarRatingForm(null);
                    setZChatDepartmentBtn(1);
                    $('.epromotor-form').removeClass('epromotor-form--disabled');

                    $.each($('.epromotor-star__item'), function(idx, item){ $(this).removeClass('active'); });

                    setZChatValInit();

                    $('#epromotorCommType').hide();
                    $('.epromotor-contents__inner').scrollTop(0);
                    $('.epromotor-confirm-layer').remove();
                    socketClosed = false;
                });
            }catch(e){

                zChat.setVisitorInfo(visitorInfo, function(err) { if(!err){ }});
                zChat.clearVisitorDefaultDepartment(function(err) { if(!err){ }});

                setZChatDelCookie(['zchatppchk', 'zchatdata']);
                $('.epromotor-chat-dom').remove();
                $('.epromotor-category-dom').remove();
                $('#epromotorMainCategory').remove();
                $('#epromotorSubCategory').remove();
                setZChatInitProc();
                setZChatStarRatingForm(null);
                setZChatDepartmentBtn(1);
                $('.epromotor-form').removeClass('epromotor-form--disabled');

                $.each($('.epromotor-star__item'), function(idx, item){ $(this).removeClass('active'); });

                setZChatValInit();

                $('#epromotorCommType').hide();
                $('.epromotor-contents__inner').scrollTop(0);
                $('.epromotor-confirm-layer').remove();
                socketClosed = false;

            }

            $(document).find('.epromotor-bottom').removeClass('epromotor-bottom--active');
        }

    function setZChatSelectedBtn(obj_string, id, tracking_id)
        {
            var txt='', timeStr='', trackingId='';
            if( typeof(obj_string) === 'string' )
                {
                    txt = obj_string;
                    timeStr = setZChatUnixToTime(getZChatUnixTime());
                }
            else if( typeof(obj_string) === 'object' )
                {
                    txt = unescape(obj_string[3]);
                    timeStr = obj_string[2];
                }
            //특정 element에 append 해야 할 때를 위해
            if( typeof(tracking_id) !== 'undefined' ){
              trackingId = ' id="'+tracking_id+'" ';
            }

            var html = '';
            html =  '<div class="epromotor-chat__message epromotor-chat__message--sent epromotor-chat__message--etc-group epromotor-category-dom" '+trackingId+'>'+
                        '<div class="epromotor-btn-group">'+
                            '<button type="button" class="epromotor-btn epromotor-btn--bubble-selected">'+
                                txt +
                            '</button>'+
                        '</div>'+
                        '<span class="epromotor-chat__time">'+
                            timeStr +
                        '</span>'+
                    '</div>';
            setAppendChatLine(html, 'after', id);
            return;
        }
    //대기 중일 때 Email 링크 버튼을 위해 별도 처리
    function setZChatSelectedEmailBtn(obj_string, id, tracking_id)
        {
            var txt='', timeStr='', trackingId='';
            if( typeof(obj_string) === 'string' )
                {
                    txt = obj_string;
                    timeStr = setZChatUnixToTime(getZChatUnixTime());
                }
            else if( typeof(obj_string) === 'object' )
                {
                    txt = unescape(obj_string[3]);
                    timeStr = obj_string[2];
                }
            //특정 element에 append 해야 할 때를 위해
            if( typeof(tracking_id) !== 'undefined' ){
                trackingId = ' id="'+tracking_id+'" ';
            }

            var html = '';
            html =  '<div class="epromotor-chat__message epromotor-chat__message--sent epromotor-chat__message--etc-group epromotor-category-dom" '+trackingId+'>'+
                        '<div class="epromotor-btn-group">'+
                            '<button type="button" class="epromotor-btn epromotor-btn--bubble-selected" id="epromoterWaitingEmailBtn">'+
                                txt +
                            '</button>'+
                        '</div>'+
                        '<span class="epromotor-chat__time">'+
                            timeStr +
                        '</span>'+
                    '</div>';
            setAppendChatLine(html, 'after', id);

            $('#epromoterWaitingEmailBtn').on('click', function(){
                window.open(config.sendEmailUrl);
            });
            return;
        }
    
    // LGEMS-378 START
    function setZchatWhatsAppBtn( officeFlag, beforeAfter, idName) {
    	if( $("#epromoter-select-chat-btn").length <= 0){
    		var time = setZChatUnixToTime(getZChatUnixTime());
            var msgHtml = '<div class="epromotor-chat__message epromotor-chat__message--receive" id="epromoter-select-chat-msg">' +
                                '<div class="epromotor-chat__string">'+
                                    config.goToWhatsAppMsg +
                                '</div>'+
                                '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+
                                    time +
                                '</span>'+
                            '</div>';
            
            var btnHtml = '<div class="epromotor-chat-category" id="epromoter-select-chat-btn">'+
                                '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotor-chat-whatsApp-btn" title="'+config.openInNewWindowMessage+'">'+
                                    config.whatsAppBtnText
                                +'</button>'+
                                '<button type="button" class="epromotor-btn epromotor-btn--bubble" id="epromotor-chat-lg-chatbot-btn">'+
                                        config.backToLGchatbotBtnText
                                +'</button>'
                        +'</div>';

            
            // LGEMS-394 start
            if( officeFlag == null || officeFlag != "Y"){
            	setAppendChatLine(msgHtml + btnHtml, 'before', 'epromotorPrivacyPolicyForm');
            }else{
            	setAppendChatLine(btnHtml, beforeAfter==null?'before':beforeAfter, idName==null?'epromotorPrivacyPolicyForm':idName);
            }
            // LGEMS-394 end

            $('#epromotor-chat-whatsApp-btn').on('click', function(){
                var url = config.whatsAppUrl;
                window.open(url);
            });

            $('#epromotor-chat-lg-chatbot-btn').on('click', function(){
            	chatbotOfflineChangeFlag = true; // LGEMS-394
                return getZChatChatbotWidget('mainCatBtn'); 
            });
    	}
    }
    // LGEMS-378 END

    function setZChatDepartmentBtn(depth)
        {
            var html1 = '', html2 = '', btnHtml1 = '', btnHtml2 = '';
            var filterGroupArr=[], fileterTemp=[], temp=[], depth2Arr=[];
            var maxDepth = 0;
            var allGroupArr = zChat.getAllDepartments();
            var isFaq = false;
            var videoGroupArr = [];

            $.each(allGroupArr, function(idx, item){
              if( item.name.match(departmentRegexp) ){ filterGroupArr.push(item); }
            });

            var tempArr = [];
            //정규식으로 일단 해당 prefix가진 것을 걸러내고 depth(1_1_3)를 배열([1,1,3])을 만든다.
            $.each(filterGroupArr, function(idx, item){
                if( item.status !== 'online' ){return;}

                item.name = $.trim(item.name);

                //showroom 상담원이 online 인지 구분하기 위해.
                if( item.name.match(departmentVideoRegexp) ){ videoGroupArr.push(1); }

                temp = item.name.split('_');
                fileterTemp = new Array();

                for(var i =0; i < temp.length; i++)
                    {
                        if( isNaN( parseInt(temp[i]) ) )
                            {
                                temp.splice(i, 1);
                                i--;
                            }
                        else
                            {
                                fileterTemp.push( parseInt(temp[i]) );
                            }
                    }

                var fileterTempJoin = item.name.replace(departmentRegexp, '').replace(fileterTemp.join('_') + '_', '').replace('_', ' ');

                if( fileterTemp.length == 2 )
                    {
                        btnHtml1 += '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" '+
                                      ' data-department-id="' + item.id + '" '+
                                      ' data-department-name="' + item.name + '" '+
                                      ' data-main-depth="' + (fileterTemp[0] + 1) + '" '+
                                      ' data-sub-depth="' + (fileterTemp[fileterTemp.length-1]) + '">'+
                                       fileterTempJoin +
                                    '</button>';
                    }
                else if( fileterTemp.length == 3 )
                    {
                        isFaq = fileterTemp[1] === 3 ? true : isFaq;
                        item['tmp'] = fileterTemp;
                        depth2Arr.push(item);
                        tempArr.push(fileterTemp);
                    }
            });

            //2_1_1과 2_1_10 을 오름차순 정렬이 되지 않기 때문에 재정렬.
            var ascSort = depth2Arr.sort(function(a, b) { return a.tmp[2] - b.tmp[2]; });
            depth2Arr = ascSort;

            if( btnHtml1 )
                {
                    var hidden = getChkCookieValidation('zchatdata') ? 'style="display:none;"' : '';

                    if( config.chatbotUseYn == 'Y' )
                        {
                            btnHtml1 += '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" id="epromotor-chatbot-button">' + config.chatbotLocalTitle + '</button>';
                        }

                    html1 = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--etc-group" id="epromotorMainCategory" ' + hidden + '>'+
                              '<div class="epromotor-btn-group">'+
                                btnHtml1 +
                              '</div>'+
                            '</div>';

                    setAppendChatLine(html1, 'before', 'epromotorPrivacyPolicyForm');
                }

            //새탭/새로고침 대응 쿠키가 있으면 아래 프로세스를 통해 버튼들을 그린다.
            if( getChkCookieValidation('zchatdata') )
                {
                    var zchatCookieMain = getZChatCookieParse('zchatdata').maindepth;
                    var zchatCookieSub = getZChatCookieParse('zchatdata').subdepth;
                    var zchatCookieChatType = getZChatCookieParse('zchatdata').chattype;
                    var returnHtml='';

                    $('#epromotorMainCategory button,#epromotorMainCategory button').attr('disabled', true);

                    //역순으로 append
                    //메인카테고리가 product / shopping 일 경우만
                    //maindepth(category 1_1 / 1_2 / 1_3)는 예약번호라서 고정.
                    if( $.inArray(zchatCookieMain[1], [1,2,3]) !== -1 )
                        {
                            if( zchatCookieMain[1] === 1 && zchatCookieChatType[2] !== '' )
                                {
                                    setZChatSelectedBtn(zchatCookieChatType, 'epromotorMainCategory');
                                    returnHtml = setZChatReturnLine({'msg':config.consulation, 'time':zchatCookieChatType[2]});
                                    setAppendChatLine(returnHtml, 'after', 'epromotorMainCategory');
                                }
                            if( zchatCookieSub[0] > 0 )
                                {
                                    setZChatSelectedBtn(zchatCookieSub, 'epromotorMainCategory');
                                    returnHtml = setZChatReturnLine({'msg':config.category1, 'time':zchatCookieSub[2]});
                                    setAppendChatLine(returnHtml, 'after', 'epromotorMainCategory');
                                }
                            if( zchatCookieMain[1] == 3 && isFaq )
                                {
                                    setZChatSelectedBtn(zchatCookieChatType, 'epromotorMainCategory');
                                    returnHtml = setZChatReturnLine({'msg':config.category3, 'time':zchatCookieMain[2]});
                                    setAppendChatLine(returnHtml, 'after', 'epromotorMainCategory');
                                }
                        }
                    else
                        {
                            if( zchatCookieSub[0] > 0 )
                                {
                                    setZChatSelectedBtn(zchatCookieSub, 'epromotorMainCategory');
                                }
                        }

                    if( zchatCookieMain[0] > 0 )
                        {
                            setZChatSelectedBtn(zchatCookieMain, 'epromotorMainCategory');
                        }
                }

            //중복 이벤트 방지
            $('#epromotorMainCategory button').unbind('click');
            $('#epromotorSubCategory button').unbind('click');

            //새탭으로 열거나 새로 고침 시 zendesk에 선택한 카테고리 로그를 저장할 수 없으므로 main/sub 카테고리 버튼을 누를 때마다 배열에 저장 후
            //privacy submit 버튼을 누를 때 쿠키로 저장한다. 마찬가지로 새탭/새로고침 시 쿠키를 기반으로 화면에 버튼을 표시한다.
            $('#epromotorMainCategory button').on('click', function(){

                //chatbot 대응으로 LG chatbot 버튼을 누르면 chatbot으로 전환.
                // LGEMS-378 : 멕시코의 경우 Servicio / Calidad 버튼 클릭시 모바일 일 때만 (문구 + 왓츠앱 or LG chatbot 버튼) 이 나오도록 함.
                if($(this).attr('id') == 'epromotor-chatbot-button' ){ 
                    if(config.localeCode == 'MX' && isMobile()){
                        setZchatWhatsAppBtn();
                    }else{
                        return getZChatChatbotWidget('mainCatBtn'); 
                    }
                }

                if( isNaN( parseInt( $(this).attr('data-main-depth') ) ) || isNaN( parseInt( $(this).attr('data-sub-depth') ) ) ){ return; }

                globalDepartmentId = parseInt( $(this).attr('data-department-id') );
                var mainDepth = parseInt( $(this).attr('data-main-depth') );
                var subDepth = parseInt( $(this).attr('data-sub-depth') );
                var temp=[], fileterTemp=[], btnCntArr=[];

                selectedData.maindepth[0] = mainDepth;
                selectedData.maindepth[1] = subDepth;
                selectedData.maindepth[2] = setZChatUnixToTime(getZChatUnixTime());
                selectedData.maindepth[3] = escape($(this).text());
                selectedData.maindepth[4] = globalDepartmentId;

                $('.epromotor-category-dom').remove();

                setZChatSelectedBtn($(this).text(), 'epromotorMainCategory');
                var showCnt = 0;
                var btnHtml='', html='', faqHtml='';
                var isFaq = false;

                $.each(depth2Arr, function(idx, item){
                    item.name = $.trim(item.name);
                    temp = item.name.split('_');
                    fileterTemp = new Array();

                    for(var i =0; i < temp.length; i++)
                        {
                            if( isNaN( parseInt(temp[i]) ) )
                                {
                                    temp.splice(i, 1);
                                    i--;
                                }
                            else
                                {
                                    fileterTemp.push( parseInt(temp[i]) );
                                }
                        }

                    if( subDepth == (fileterTemp[1]) )
                        {
                            btnCntArr.push(0);
                            var fileterTempJoin = this.name.replace(departmentRegexp, '').replace(fileterTemp.join('_') + '_', '').replace('_', ' ');
                            /*if( showCnt%4 === 0 ){ btnHtml += '<div class="epromotor-chat-category-row">'; }
                            btnHtml += '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" '+
                                          ' data-department-id="' + item.id + '" '+
                                          ' data-department-name="' + item.name + '" '+
                                          ' data-main-depth="' + fileterTemp[0] + '" '+
                                          ' data-sub-depth="' + (fileterTemp[fileterTemp.length-2]) + '">'+
                                           fileterTempJoin +
                                        '</button>';
                            if( showCnt > 0 && ( showCnt + 1 )%4 === 0 ){ btnHtml += '</div>'; }*/

                            btnHtml +=  '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" '+
                                            ' data-department-id="' + item.id + '" '+
                                            ' data-department-name="' + item.name + '" '+
                                            ' data-main-depth="' + fileterTemp[0] + '" '+
                                            ' data-sub-depth="' + (fileterTemp[fileterTemp.length-2]) + '">'+
                                            fileterTempJoin +
                                        '</button>';

                            if( subDepth === 3 && fileterTemp.length > 0 )
                                {
                                    isFaq = true;
                                    faqHtml +=  '<div class="epromotor-chat-category-row">'+
                                                  '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" '+
                                                    ' data-main-depth="' + fileterTemp[0] + '" '+
                                                    ' data-sub-depth="' + (fileterTemp[fileterTemp.length-2]) + '">'+
                                                     fileterTempJoin +
                                                  '</button>'+
                                                '</div>';
                                }
                            showCnt++;
                        }
                });

                //showCnt%3에서 마지막 </div> 가 없을 경우.
                if( btnCntArr.length%4 > 0 ){ btnHtml += '</div>'; }

                if( showCnt > 0 )
                    {
                        var botHtml1 = '';
                        if( subDepth == 1 )
                            {
                              botHtml1 = setZChatReturnLine({'msg':config.category1, 'time':setZChatUnixToTime(getZChatUnixTime())});
                            }
                        else if( subDepth == 2 )
                            {

                            }
                        else if( subDepth == 3 && isFaq )
                            {
                              botHtml1 = setZChatReturnLine({'msg':config.category3, 'time':setZChatUnixToTime(getZChatUnixTime())});
                            }

                        html += botHtml1;
                    }

                if( subDepth == 3 )
                    {
                        if( isFaq )
                            {
                                /*html += '<div class="epromotor-chat-category epromotor-category-dom" id="epromotorFaqCategory">'+
                                          '<div class="swiper-container" id="categorySelector">'+
                                            '<div class="swiper-wrapper">'+
                                              '<div class="swiper-slide">'+
                                                  faqHtml +
                                                '<div class="epromotor-chat-category-row">'+
                                                  '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" id="epromotorCommTypeChat">'+config.btnSelectionChat+'</button>'+
                                                '</div>'
                                              '</div>'+
                                            '</div>'+
                                          '</div>'+
                                        '</div>';*/
                                html += '<div class="epromotor-chat-category epromotor-category-dom" id="epromotorFaqCategory">'+
                                            faqHtml +
                                            '<div class="epromotor-chat-category-row">'+
                                                '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" id="epromotorCommTypeChat">'+config.btnSelectionChat+'</button>'+
                                            '</div>'
                                        '</div>';
                            }
                    }
                else
                    {
                        html += '<div class="epromotor-chat-category" id="epromotorSubCategory">'+ btnHtml + '</div>';
                    }

                $('.epromotor-chat-category').remove();

                setAppendChatLine(html, 'before', 'epromotorPrivacyPolicyForm');

                if( showCnt < 1 )
                    {
                        if( subDepth == 1 )
                            {

                            }
                        else
                            {
                                if( isFaq )
                                    {
                                        var returnHtml = setZChatReturnLine({'msg':config.consulation, 'time':setZChatUnixToTime(getZChatUnixTime())});
                                        setAppendChatLine(returnHtml, 'before', 'epromotorPrivacyPolicyForm');
                                        $('#epromotorSubCategory').remove();
                                    }
                            }
                    }

                /*if( $('#categorySelector').length > 0 )
                    {
                      var categorySwiper = new CategorySwiper('#categorySelector');
                    }*/

                if( showCnt < 1 )
                    {
                        if( subDepth == 2 )
                            {
                                selectedData.chattype[2] = setZChatUnixToTime(getZChatUnixTime());
                                selectedData.chattype[3] = escape($(this).text());
                                $('#epromotorPrivacyPolicyForm').show();
                                $('.epromotor-contents__inner').scrollTop(300);
                                //LGCOMMON-5306 START
                                if(config.fullNameUseFlag == 'Y'){
                                	$('#epromotorUserFullName').focus();
                                }else{
                                	$('#epromotorUserFirstName').focus();
                                }
                                //LGCOMMON-5306 END
                            }
                        else
                            {
                                if( isFaq )
                                    {
                                        setZChatChatFuncButton(channelType, false)
                                    }
                                else
                                    {
                                        $('#epromotorPrivacyPolicyForm').show();
                                        $('.epromotor-contents__inner').scrollTop(300);
                                        //LGCOMMON-5306 START
                                        if(config.fullNameUseFlag == 'Y'){
                                        	$('#epromotorUserFullName').focus();
                                        }else{
                                        	$('#epromotorUserFirstName').focus();
                                        }
                                        //LGCOMMON-5306 END
                                    }
                            }
                    }

                $('#epromotorSubCategory').show();
                $('#epromotorMainCategory').remove();
                setZChatTimeCookie('');

                $('#epromotorSubCategory button').on('click', function(){
                    if( isNaN( parseInt( $(this).attr('data-main-depth') ) ) || isNaN( parseInt( $(this).attr('data-sub-depth') ) ) ){ return; }
                    globalDepartmentId = parseInt( $(this).attr('data-department-id') );
                    var mainDepth = parseInt( $(this).attr('data-main-depth') );
                    var subDepth = parseInt( $(this).attr('data-sub-depth') );
                    var returnHtml = '';

                    selectedData.subdepth[0] = mainDepth;
                    selectedData.subdepth[1] = subDepth;
                    selectedData.subdepth[2] = setZChatUnixToTime(getZChatUnixTime());
                    selectedData.subdepth[3] = escape($(this).text());
                    selectedData.subdepth[4] = globalDepartmentId;
                    $.each($('.epromotor-category-dom'), function(idx, item){
                        //subdepth 다음 삭제.
                        if( idx > 0 ){ $(this).remove() }
                    });

                    setZChatSelectedBtn($(this).text(), 'epromotorSubCategory');
                    $('#epromotorSubCategory').remove();

                    if( channelType.length > 1 && $.inArray(subDepth, [1,2,3]) !== -1 )
                        {
                            returnHtml = setZChatReturnLine({'msg':config.consulation, 'time':setZChatUnixToTime(getZChatUnixTime())});
                            setAppendChatLine(returnHtml, 'before', 'epromotorPrivacyPolicyForm');

                            videoGroupArr.length > 0 ? setZChatChatFuncButton(channelType, false) : setZChatChatFuncButton(['chat'], false);

                            setZChatScrollTop();
                            setZChatTimeCookie('');
                        }
                    else
                        {
                            $('#epromotorPrivacyPolicyForm').show();
                            $('.epromotor-contents__inner').scrollTop(300);
                            //LGCOMMON-5306 START
                            if(config.fullNameUseFlag == 'Y'){
                            	$('#epromotorUserFullName').focus();
                            }else{
                            	$('#epromotorUserFirstName').focus();
                            }
                            //LGCOMMON-5306 END
                        }
                });
                $('#epromotorFaqCategory button').on('click', function(){
                    var btnIdx = $('#epromotorFaqCategory button').index($(this));
                    //Chat with specialist 버튼일 경우.
                    if( btnIdx > 2)
                      {
                        selectedData.chattype[2] = setZChatUnixToTime(getZChatUnixTime());
                        selectedData.chattype[3] = escape($(this).text());
                        setZChatSelectedBtn($(this).text(), 'epromotorFaqCategory');
                        setZChatTimeCookie('');
                        return;
                      }

                    var faqUrl = config['faqUrl' + (btnIdx + 1)];
                    window.open(faqUrl);
                    setZChatTimeCookie('');
                });
                //service / Quality (main category의 3번째 버튼:faq category button)
                if( subDepth == 3 )
                    {
                        $("#epromotorCommTypeChat").on('click', function(){
                            $('#epromotorPrivacyPolicyForm').show();
                            $('#epromotorFaqCategory').remove();
                            //setZChatScrollTop();
                            $('.epromotor-contents__inner').scrollTop(300);
                            //LGCOMMON-5306 START
                            if(config.fullNameUseFlag == 'Y'){
                            	$('#epromotorUserFullName').focus();
                            }else{
                            	$('#epromotorUserFirstName').focus();
                            }
                            //LGCOMMON-5306 END
                        });
                    }
            });
        }

    function setZChatTimeCookie(stime)
        {
            var temp;
            var _stime = stime;
            var unixTime = getZChatUnixTime();
            var startTime = setZChatUnixToTime(unixTime);

            //setZChatInitProc에서 편집된 filterChatLog가 비어있으면 $.cookie('zchatproclog')가 삭제되어있으니.
            if( !getChkCookieValidation('zchatproclog') )
                {
                    temp = {'starttime':startTime, 'startunixtime':unixTime, 'privptime':'', 'welcomecmttime':'', 'star':'', 'mkt':'', 'email':''};
                    $('span[name=epromotorDefualtChatTime]').eq(0).text(startTime);
                }
            else
                {
                    //$.cookie('zchatproclog') 가 있으면 카테고리 버튼을 누르지 않았으면 temp.privptime 설정값이 없고 temp.privptime설정값이 있으면 기존값에 새 시간을 덮어쓰지 않는다.
                    temp = getZChatCookieParse('zchatproclog');
                    temp.privptime = temp.privptime == '' ? startTime : temp.privptime;

                    //welcomeCmt에서 들어오면 설정
                    if( _stime !== '' ){ temp.welcomecmttime = temp.welcomecmttime == '' ? _stime : temp.welcomecmttime; }

                    $('span[name=epromotorDefualtChatTime]').eq(0).text(temp.starttime);
                    $('span[name=epromotorDefualtChatTime]').eq(1).text(temp.privptime);
                    $('span[name=epromotorDefualtChatTime]').eq(2).text(temp.welcomecmttime);
                    //$('#epromotorStarUi').attr('data-star-value', temp.star);
                }

            return setZChatCookie(temp, 'zchatproclog', 'json');
        }

    function getZChatCookieParse(key)
        {
            var temp;
            if( key == 'zchatdata' ){
                temp = selectedData;
            }

            try{
                temp = JSON.parse( $.cookie(key) )
            }catch(e){

            }
            return temp;
        }

    function setZChatCookie(data, key, type)
        {
            return type == 'json' ?
                    $.cookie(key, JSON.stringify(data), { expires: 1, path: '/' }) :
                    $.cookie(key, data, { expires: 1, path: '/' });
        }

    function setZChatDelCookie(cookie_name_arr)
        {
            if( Array.isArray(cookie_name_arr) === false ){ return; }
            var arrLen = cookie_name_arr.length;
            for( var i = 0; i < arrLen; i++ )
                {
                    $.removeCookie(cookie_name_arr[i], {path: "/"});
                }
            return;
        }

    function setZChatSendFileErrorHandle(error)
        {
            var errorArr = {
                'NOT_SUPPORTED':'NOT_SUPPORTED',
                'NOT_ALLOWED':'NOT_ALLOWED',
                'CONN_ERROR':'CONN_ERROR',
                'INVALID_EXTENSION':'INVALID_EXTENSION',
                'EXCEED_SIZE_LIMIT':'EXCEED_SIZE_LIMIT',
                'INTERNAL_ERROR':'INTERNAL_ERROR',
                'UNKNOWN_ERROR':'UNKNOWN_ERROR'
            }
            return typeof(errorArr[error]) !== 'undefined' ? errorArr[error] : 'Unknown error.';
        }

    function reqRatingstarUi()
        {
            var starValEl = $('#epromotorStarUi.epromotor-star');
            if (!starValEl.length) return false;
            var range = $('input.epromotor-star__range');
            var starItems = $('#epromotorStarUi .epromotor-star__item');

            range.on('click touchend', function(e){

                if( !epromoterStarEnable ) return;

                $('#epromotorChatTextarea').removeAttr('disabled');
                $('#epromotorReqRatingSubmit').removeAttr('disabled');

                $('#epromotorRateDesc') ? $('#epromotorRateDesc').remove() : '';

                var rangeVal = parseInt( $(this).val() );
                var dataVal = isNaN(parseInt( $(this).attr('data-star-value') )) ? 0 : parseInt( $(this).attr('data-star-value') );

                $.each(starItems, function(idx, el){ (idx + 1) <= rangeVal ? $(el).addClass('active') : $(el).removeClass('active'); });
                $('#epromotorStarUi').attr('data-star-value', rangeVal);

            });
        }

    // LGEMS-394 : chatbotOfflineOnlineBtnFlag 추가
    function getZChatChatbotWidget(from)
        {
            var status = 'offline';
            var newChatFlag = "N";
            if($('.navigation.b2c').data('newChatFlag') && $('.navigation.b2c').data('newChatFlag') == "Y"){
            	newChatFlag = $('.navigation.b2c').data('newChatFlag');
            }
            	
            if ( config.chatbotUseYn == 'Y' )
                {
                    status = getZChatFilterAgentStatus();
                    
                    // LGEMS-474, LGEPA-952, LGEPE-407 start
                    var latamChatbotActionFlag = false;
                    
                    if(config.allLatamChatbotActionFlag == "Y"){
                    	chatbotOfflineChangeFlag = true;
                    	latamChatbotActionFlag = true;
                    } else {
                    	if(typeof _dl.page_name.page_purpose != 'undefined'){
                    		if(_dl.page_name.page_purpose.toLowerCase() == "cs" && config.cstLatamChatbotActionFlag == "Y"){
                            	chatbotOfflineChangeFlag = true;
                            	latamChatbotActionFlag = true;
                            }
                        }
                        
                        if(typeof standardData != "undefined"){
                        	if(standardData.level1.toLowerCase() == "my-lg" && config.accLatamChatbotActionFlag == "Y"){
                        		chatbotOfflineChangeFlag = true;
                        		latamChatbotActionFlag = true;
                        	}
                        }                    	
                    }
                    // LGEMS-474, LGEPA-952, LGEPE-407 end

                    
                    // LGEMS-394 start
                    if(config.chatbotOfflineOnlineBtnFlag == "Y" && status != "online" && (chatbotOfflineChangeFlag == null || !chatbotOfflineChangeFlag)){
            	 		setZChatOfflineInit();
        			}else{
        				chatbotOfflineChangeFlag = false; 
        				if( config.chatbotOfflineOnlineBtnFlag == "Y" && status == "online"){
        					$(document).find('.epromotor-chat').addClass('epromotor-chat--ready epromotor-chat--active');
    	                    $('#epromotorOffline').hide();
        			 		$('.epromotor-contents__inner #epromotor-chatbot-offline-append').remove();
        			 		$('.epromotor-contents__inner #epromoterChatDomDiv:gt(0)').remove();
        			 		if( $("#epromotorMainCategory").length <= 0 && $("#epromotorPrivacyPolicyForm").css("display") == "none"){
        			 			setZChatDepartmentBtn(1);
        			 		}
        			 		
        				}
        				// LGEMS-394 end
        				if(!hideChatbotWidget){
        					$('#epromoter-chatbot-iframe').remove();
        					$('.iframe_type').remove();
        				}
			    /* LGEMS-359, LGEMS-378 */
			            if(config.chatbotIframeDragFlag =='Y' && !isMobile()){                        
	                    	var $iframehtml = $('<div class="chat_drag iframe_type"><div class="chat_bar"></div><iframe class="epromotor-chatbot-area ready active" id="epromoter-chatbot-iframe" src="' + config.chatbotUrl + '" style="display:none;"></iframe></div>');
	                    	$iframehtml.find("#epromoter-chatbot-iframe").on('load', function(e){
	                            $('.epromotor-widget-area, .epromotor-chat-area').removeClass('ready active');
	                            $(this).show();
	                        });
	                    }else{
	                    	//PJTCHATBOT-4 add
	                    	if($('.chat-msg').length && $('.chat-msg').hasClass('ready') && $('#chat-msg1').hasClass('active')){
	                    		console.log("isMain" + ISMAIN);
	                    		var paramUrl = config.chatbotUrl + "&svcType="+$('.chat-msg-area').data('svcType');
	                    		if($('.chat-msg-area').data('scenario')){
	                    			paramUrl += "&scenario="+$('.chat-msg-area').data('scenario');
	                    		}
	                    		if($('.chat-msg-area').data('cate2')){
	                    			paramUrl += "&cate2="+$('.chat-msg-area').data('cate2');
	                    		}
	                    		if($('.chat-msg-area').data('cate3')){
	                    			paramUrl += "&cate3="+$('.chat-msg-area').data('cate3');
	                    		}
	                    		if($('.chat-msg-area').data('model')){
	                    			paramUrl += "&model="+$('.chat-msg-area').data('model');
	                    		}
	                    		if($('.chat-msg-area').data('recommType')){
	                    			paramUrl += "&recommType="+$('.chat-msg-area').data('recommType');
	                    		}
	                    		
	                    		var $iframehtml = $('<iframe class="epromotor-chatbot-area ready active" id="epromoter-chatbot-iframe" src="' + paramUrl + '" style="display:none;"></iframe>');
	                    		$iframehtml.on('load', function(e){
	                    			$('.chat-msg, .chat-msg-area').removeClass('ready active');
	                    			$(this).show();
	                    		});
	                    	}else{
	                    		var $iframehtml = $('<iframe class="epromotor-chatbot-area ready active" id="epromoter-chatbot-iframe" src="' + config.chatbotUrl + '" style="display:none;"></iframe>');
	                    		$iframehtml.on('load', function(e){
	                    			$('.epromotor-widget-area, .epromotor-chat-area').removeClass('ready active');
	                    			$(this).show();
	                    		});
	                    	}
	                    }
			    /* LGEMS-359 */
			            
			            //PJTCHATBOT-4 start 신규 챗봇 Y 이면 
			            if(newChatFlag == "Y" ){
			            	if(hideChatbotWidget){
                        		$('.epromotor-widget-area').removeClass('ready active');
                        		$('.epromotor-chatbot-area').addClass('ready active');
                        		hideChatbotWidget = false;
	                        }else{
	                        	$('body').append($iframehtml);
	                        }
                        }else{
                        	if( status == 'online')
		                        {
		                            if( from == 'mainCatBtn' ){
		                                $('body').append($iframehtml);
		                            }else{
		                            	// LGEMS-474 start
		                            	if(latamChatbotActionFlag){
		                            		$('body').append($iframehtml);
		                            	} else {
		                            		$('.epromotor-widget-area').removeClass('ready active');
			                                $('.epromotor-chat-area').addClass('ready active');
		                            	}
		                            	// LGEMS-474 end
		                            }
		                        }
		                    else
		                        {
		                            if($(".iframe_type").length < 1 == true){
	                            		$('body').append($iframehtml);
		                            }
		                        }
                        }
			            //PJTCHATBOT-4 end
        			}
                }
            else
                {
	            	// LGEMS-394 start
	        		status = getZChatFilterAgentStatus();
	        	
	        	 	if(config.chatbotOfflineOnlineBtnFlag == "Y" && status == "offline"){
	        	 		setZChatOfflineInit()();
	    			}else{
	                    $('.epromotor-widget-area').removeClass('ready active');
	                    $('.epromotor-chat-area').addClass('ready active');
	    			}
	        	 	// LGEMS-394 end
                }
            /* LGEMS-359, LGEMS-378 */
            if(config.chatbotIframeDragFlag =='Y' && !isMobile()){
            	$( ".iframe_type" ).draggable({ handle: ".chat_bar" , containment: "body"});
            }
             
	    /* LGEMS-359, LGEMS-378 */

        }
    
    // LGEMS-394 start
    function setZChatOfflineInit(){
    	$(document).find('.epromotor-chat').removeClass('epromotor-chat--ready epromotor-chat--active');
        $(document).find('.epromotor-bottom').removeClass('epromotor-bottom--active');
        $(document).find('.epromotor-support').addClass('epromotor-support--ready epromotor-support--active');
        $('#epromotorOffline').show();
    	
    	$('.epromotor-widget-area').removeClass('ready active');
        $('.epromotor-chat-area').addClass('ready active');
        
        if( showroomCount > 0){
        	return;
        }
        $('#epromotorOffline #chatbotOfflineGreeting').remove();
        $('#epromotorOffline #epromotorMainCategoryOffline').remove();
 		$('.epromotor-contents__inner #epromotor-chatbot-offline-append').remove();
 		$('#epromotorOffline .epromotor-category-dom').remove();
 		$('.epromotor-contents__inner #epromoter-select-chat-btn').remove();
        
        var allGroupArr = zChat.getAllDepartments();
        var filterGroupArr=[], fileterTemp=[], temp=[], depth2Arr=[], tempArr = [];
        var btnHtml1 = '';
        var isFaq = false;
        
        $.each(allGroupArr, function(idx, item){
        	if( item.name.match(departmentRegexp) ){ filterGroupArr.push(item); }
        });
        
        $.each(filterGroupArr, function(idx, item){
        	item.name = $.trim(item.name);
        	temp = item.name.split('_');
            fileterTemp = new Array();
        	
        	for(var i =0; i < temp.length; i++)
            {
                if( isNaN( parseInt(temp[i]) ) ){
                    temp.splice(i, 1);
                    i--;
                }else{
                	fileterTemp.push( parseInt(temp[i]) );
                }
            }
        	
        	var fileterTempJoin = item.name.replace(departmentRegexp, '').replace(fileterTemp.join('_') + '_', '').replace('_', ' ');
        	
        	if( fileterTemp.length == 2 )
            {
                btnHtml1 += '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" '+
                              ' id="epromotor-chatbot-offline-button"'+
                              ' data-department-id="' + item.id + '" '+
                              ' data-department-name="' + item.name + '" '+
                              ' data-main-depth="' + (fileterTemp[0] + 1) + '" '+
                              ' data-sub-depth="' + (fileterTemp[fileterTemp.length-1]) + '">'+
                               fileterTempJoin +
                            '</button>';
            }else if( fileterTemp.length == 3 ) {
                isFaq = fileterTemp[1] === 3 ? true : isFaq;
                item['tmp'] = fileterTemp;
                depth2Arr.push(item);
                tempArr.push(fileterTemp);
            }
        });
        
        //2_1_1과 2_1_10 을 오름차순 정렬이 되지 않기 때문에 재정렬.
        var ascSort = depth2Arr.sort(function(a, b) { return a.tmp[2] - b.tmp[2]; });
        depth2Arr = ascSort;
        
        if( btnHtml1 )
        {
            var hidden = '';
            
            btnHtml1 += '<button type="button" class="epromotor-btn epromotor-btn--bubble epromotor-chat-department-btn" id="epromotor-chatbot-offline-custom-button" data-idx="1">' + config.chatbotLocalTitle + '</button>';

            html1 = '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--etc-group" id="epromotorMainCategoryOffline" ' + hidden + '>'+
                      '<div class="epromotor-btn-group">'+
                        btnHtml1 +
                      '</div>'+
                    '</div>';

            setAppendChatLine(html1, 'after', 'epromoterChatDomDiv');
        }
        
        var btnHtml2 = "";
        var time = setZChatUnixToTime(getZChatUnixTime());
        if( config.chatbotOfflineGreeting1 != "N"){
        	btnHtml2 += '<div class="epromotor-chat__message epromotor-chat__message--receive" id="chatbotOfflineGreeting">'+
				            '<div class="epromotor-chat__string">'+
				            config.chatbotOfflineGreeting1 +
				          '</div>';
        	if( config.chatbotOfflineGreeting2 == "N"){
        		btnHtml2 += '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+time+
		          			'</span>';
        	}
			btnHtml2 += '</div>';
        }
        
        if( config.chatbotOfflineGreeting2 != "N"){
        	btnHtml2 += '<div class="epromotor-chat__message epromotor-chat__message--receive" id="chatbotOfflineGreeting">'+
				          '<div class="epromotor-chat__string">'+
				            config.chatbotOfflineGreeting2 +
				          '</div>'+
				          '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+time+
				          '</span>'+
				        '</div>';
        }
        
        setAppendChatLine(btnHtml2, 'after', 'epromoterChatDomDiv');
        
        $(this).show();
        setTimeout(function(){setZChatScrollTop();}, 30);
        
        $('#epromotorMainCategoryOffline #epromotor-chatbot-offline-custom-button').unbind('click');
        $('#epromotorMainCategoryOffline #epromotor-chatbot-offline-custom-button').on('click', function(){
        	if(config.localeCode == 'MX' && isMobile()){
        		var offlineMsg = config["goToWhatsAppMsg"];
            	
//            	$('#epromotorOffline #chatbotOfflineGreeting').remove();
//            	$('#epromotorOffline #epromotorMainCategoryOffline').remove();
//            	setZChatSelectedBtn($(this).html(), 'epromoterChatDomDiv');
        		if(  $('#epromotor-chatbot-offline-append').length <= 0){
        			appendZChatMessage(offlineMsg,'#epromotorOffline');
                	
                	//chatbot 대응으로 LG chatbot 버튼을 누르면 chatbot으로 전환.
                    // LGEMS-378 : 멕시코의 경우 Servicio / Calidad 버튼 클릭시 모바일 일 때만 (문구 + 왓츠앱 or LG chatbot 버튼) 이 나오도록 함.
                    if(config.localeCode == 'MX'){
                    	setZchatWhatsAppBtn( 'Y', 'after', 'epromotor-chatbot-offline-append');
                    }
        		}
        	}else{
        		chatbotOfflineChangeFlag = true; // LGEMS-394
                return getZChatChatbotWidget('mainCatBtn');
        	}
        });
        
        $('#epromotorMainCategoryOffline #epromotor-chatbot-offline-button').unbind('click');
        $('#epromotorMainCategoryOffline #epromotor-chatbot-offline-button').on('click', function(){
        	var subDepth = $(this).attr('data-sub-depth');
        	var offlineMsg = config["chatbotOfflineBtnMsg"+subDepth];
        	
        	$('#epromotorOffline #chatbotOfflineGreeting').remove();
        	$('#epromotorOffline #epromotorMainCategoryOffline').remove();
        	setZChatSelectedBtn($(this).html(), 'epromoterChatDomDiv');
        	appendZChatMessage(offlineMsg,'.epromotor-contents__inner');
        });
    }
    
    function appendZChatMessage( offlineMsg, name){
    	if( offlineMsg != undefined && offlineMsg != "N"){
    		$('#epromotor-chatbot-offline-append').remove();
    		$('#epromoter-select-chat-btn').remove();
    		
    		var time = setZChatUnixToTime(getZChatUnixTime());
    		var appendHtml = '';
    		appendHtml +=  '<div class="epromotor-chat__message epromotor-chat__message--receive" id="epromotor-chatbot-offline-append">';
    		appendHtml +=  '<div class="epromotor-chat__string">';
    		appendHtml += offlineMsg;
    		appendHtml += '</div>';
    		appendHtml += '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">';
    		appendHtml += time;
    		appendHtml += '</span>';
    		appendHtml += '</div>';
            
            $(name).append(appendHtml);
            showroomCount++;
            setTimeout(function(){setZChatScrollTop();}, 30);
    	}
    }
    // LGEMS-394 end

    function setZChatInstanceInit()
        {
            reqRatingstarUi();

            //downloadValueSet(document.querySelector('#downloadC .epromotor-chat__download-circle'), 60);

            bottomCheck.init();
            bottomCheck.update();

            zChat.init( {account_key : appkey} );

            zChat.on('connection_update', function(status) {

                //모바일 단말기에서 전원 버튼을 누르고 다시 들어올 때 이벤트가 다시 발생되는 경우 예외 처리.
                if (status === 'closed')
                    {
                        zChat.un('chat', zChatEvtHandler);
                        zChat.on('chat', zChatEvtHandler);
                        conversationEnd = true;
                        socketClosed = true;
                        setZChatAgentStatus();
                        setZChatEndNoConfirm();
                    }
                else if (status === 'connecting')
                    {
                        zChat.un('chat', zChatEvtHandler);
                    }
                else if (status === 'connected')
                    {
                        if( loadedWidget )
                            {
                                zChat.on('chat', zChatEvtHandler);
                                if( !zChat.isChatting() )
                                    {
                                        conversationEnd = true;
                                        setZChatEndNoConfirm();
                                    }

                                return;
                            }

                        loadedWidget = true;

                        var chatLen = setZChatInitProc();

                        setZChatDepartmentBtn(1);

                        zChat.on('chat', zChatEvtHandler);

                        if( chatLen > 0 )
                            {
                                //타이밍 문제로 인해 scrollTop 지연 시킴.
                                setTimeout(function(){setZChatScrollTop();}, 30);
                            }

                        //LGCOMMON-5306 START
                        if(config.fullNameUseFlag != 'Y'){
                        	$('#epromotorUserFirstName').val(config.loginFname);
                            $('#epromotorUserLastName').val(config.loginLname);
                        }
                        //LGCOMMON-5306 END
                        $('#epromotorUserEmail').val(config.loginEmail);

                        zChat.on('department_update', function(event_data) {
                            setZChatAgentStatus();
                        });

                        zChat.on('account_status', function(event_data) {
                            setZChatAgentStatus();
                        });
                  }
            });

            $('#epromotorTextArea').on('paste', function(e){
                var $sendBtn = $('.epromotor-container .epromotor-btn.epromotor-btn--send');
                $(this).val().length > 0 ? $sendBtn.removeAttr('disabled') : $sendBtn.attr('disabled', true);
            });

            $('#epromotorTextArea').on('keyup', function(e){
                if( e.keyCode === 13 ){ return $('.epromotor-container .epromotor-btn.epromotor-btn--send').click(); }
                var $sendBtn = $('.epromotor-container .epromotor-btn.epromotor-btn--send');
                $(this).val().length > 0 ? $sendBtn.removeAttr('disabled') : $sendBtn.attr('disabled', true);
            });

            $('#epromotorSendFile').on('change', function(){
                if( typeof($('#epromotorSendFile')[0].files[0]) !== 'undefined' )
                    {
                        //if( $('.epromotor-container .epromotor-btn.epromotor-btn--send').prop('disabled') ){ return; }
                        var fileName = $(this)[0].files[0].name;
                        $('.epromotor-container #epromotorTextArea').val( fileName );
                        $('.epromotor-container .epromotor-btn.epromotor-btn--send').removeAttr('disabled');
                    }
            });

            $('.epromotor-contents__inner').on('scroll', function(){
                if( $(this).scrollTop() - lastScrollTop < 0 ){
                    autoScrollStop = true;
                }else{
                    autoScrollStop = false;
                }
            });

            $('.epromotor-container .epromotor-btn.epromotor-btn--send').on('click', function(){
                if( !btnSendable){ return; }
                btnSendable = false;

                try{ clearTimeout(waitingTimeout180Ins); }
                catch(e){}
                finally{waitingTimeout180Ins = setTimeout(function(){ setZChatLine({'msg':config.noTyping3,'timestamp':getZChatUnixTime()}, 'agent');}, waitTimeoutSec180 * 1000);}

                try{ clearTimeout(waitingTimeout360Ins); }
                catch(e){}
                finally{waitingTimeout360Ins = setTimeout(function(){ setZChatLine({'msg':config.noTyping6,'timestamp':getZChatUnixTime()}, 'agent'); }, waitTimeoutSec360 * 1000);}

                autoScrollStop = false;

                //Allowed file ext : pdf / png / jpg / gif / txt
                if( $('#epromotorSendFile')[0].files[0] )
                    {
                        var file = $('#epromotorSendFile')[0].files[0];
                        var fileName = file.name;
                        var fileInfoArr = fileName.split('.');
                        var fileExt='',html='';

                        if( fileInfoArr.length < 2 ){ btnSendable = true; return; }

                        fileExt = fileInfoArr[ fileInfoArr.length - 1 ];

                        if( allowedFileExt.indexOf( fileExt.toLowerCase() ) === -1 )
                            {
                                $('.epromotor-container #epromotorTextArea').val('');
                                //input type file init
                                $('#epromotorSendFile').val('');
                                $(this).attr('disabled', true);
                                btnSendable = true;
                                return setZChatFileUploadExtAlert(false);
                            }

                        if( file.size < parseInt(limitedFileSize) )
                            {
                                setZChatBottomAlert('normal', config.uploadFileAlert, false);
                                zChat.sendFile(file, function(err, data) {
                                    if( !err )
                                        {
                                            setZChatBottomAlertRemove();
                                            var chat = {
                                              'attachment':{
                                                  'mime_type':data.mime_type,
                                                  'size':data.size,
                                                  'name':data.name,
                                                  'url':data.url,
                                              },
                                              'nick':'visitor',
                                              'timestamp':getZChatUnixTime()
                                            };
                                            setZChatFileLine(chat);
                                        }
                                    else
                                        {
                                            setZChatBottomAlertRemove();
                                            setZChatBottomAlert('error', setZChatSendFileErrorHandle(err.message), true);
                                        }
                                });
                            }
                        else
                            {
                                setZChatFileUpLoadAlert();
                            }

                        bottomCheck.update();
                        $('.epromotor-container #epromotorTextArea').val('');
                        $(this).attr('disabled', true);
                        btnSendable = true;
                        //input type file init
                        return $('#epromotorSendFile').val('');
                    }

                var chatText = $('.epromotor-container #epromotorTextArea').val();
                chatText = chatText.replace(/</g,'&lt;');
                chatText = chatText.replace(/>/g,'&gt;');
                chatText = chatText.replace(/\"/g,'&quot;');
                chatText = chatText.replace(/\'/g,'&#39;');
                chatText = chatText.replace(/\n$/g,'');		//LGCOMITF-176 

                if( chatText.length < 1 ){ btnSendable = true; return; }

                zChat.sendChatMsg(chatText, function(err) {
                    if(!err)
                        {
                            var _chat = {'msg':chatText, 'timestamp':getZChatUnixTime()};
                            setZChatLine(_chat, 'customer');
                            var $sendBtn = $('.epromotor-container .epromotor-btn.epromotor-btn--send');
                            $sendBtn.attr('disabled', true);
                        }

                    bottomCheck.update();
                    $('.epromotor-container #epromotorTextArea').val('');
                    $(this).attr('disabled', true);
                });
                btnSendable = true;
            });

            $('.epromotor-header__left button').on('click', function(){
                $('.epromotor-chat-area ').removeClass('ready active');
                $('.epromotor-widget-area').addClass('ready active');
                if ($(".chat_drag").hasClass('ui-draggable') == true) {
                    $( ".chat_drag" ).addClass("shrink")
                }
            });

            $('.epromotor-container .epromotor-btn.epromotor-btn--endchat').on('click', function(){
                setZChatEndConfirm();
                $('#epromotorChatTextarea').prop('disabled', true);
            });

            $('#epromotorRestartBtn').on('click', function(){
                setZChatEndConfirm();
            });

            $('#epromotorReqRatingSubmit').on('click', function(){
                var starCount = isNaN( parseInt( $('#epromotorStarUi').attr('data-star-value') ) ) ? 0 : parseInt( $('#epromotorStarUi').attr('data-star-value') );
                var goodOrBad = starCount > star ? 'good' : 'bad';
                var comment = $('#epromotorChatTextarea').val();
                var addTagRating = ['chatrating_' + goodOrBad, 'chatrating_'+ starCount.toString()];
                $('.epromotor-star__range').attr('disabled', true);

                var temp = getZChatCookieParse('zchatproclog');
                temp.star = starCount;
                setZChatCookie(temp, 'zchatproclog', 'json');

                zChat.sendChatRating(goodOrBad, function(err) { });
                zChat.sendChatComment(comment, function(err) { });
                zChat.addTags(addTagRating, function(err) { });

                setZChatMktBtn(tempForReqRating);
                //setZChatRestartButton(getZChatUnixTime());
            });

            //LGCOMMON-5306 START
            if(config.fullNameUseFlag == 'Y'){
            	$('#epromotorUserFullName,#epromotorUserEmail').on('keyup', function(e){
                    var fullName = replaceSpecialCharacter($('#epromotorUserFullName').val());
                    var emailAddress = replaceSpecialCharacter($('#epromotorUserEmail').val());
                    
                    var $submitBtn = $('.epromotor-btn.epromotor-btn--base.epromotor-policy-button');

                    if(fullName.length > 0)
	                    {
	                    	$('#epromotorUserFullName').next().hide();
	                    }

                    //validation email address format
                    if( emailAddress.length > 0 && !emailRegexp.test(String(emailAddress).toLowerCase()) )
                        {
                            $('#epromotorUserEmail').next().text(config.ppEmailError);
                            $('#epromotorUserEmail').next().show();
                        }
                    else
                        {
                            $('#epromotorUserEmail').next().text('');
                            $('#epromotorUserEmail').next().hide();
                        }

                    if( emailRegexp.test(String(emailAddress).toLowerCase()) && fullName.length > 0){
                        var checkbox = $('#epromotorPrivacyPolicyForm input:checkbox[name=epromotorppChk]');
                        if( checkbox.eq(0).prop('checked') ){
                            $submitBtn.removeAttr('disabled');
                        }
                    }
                });
            }else{
            	$('#epromotorUserFirstName,#epromotorUserLastName,#epromotorUserEmail').on('keyup', function(e){
                    var firstName = replaceSpecialCharacter($('#epromotorUserFirstName').val());
                    var lastName = replaceSpecialCharacter($('#epromotorUserLastName').val());
                    var emailAddress = replaceSpecialCharacter($('#epromotorUserEmail').val());

                    var $submitBtn = $('.epromotor-btn.epromotor-btn--base.epromotor-policy-button');

                    if( firstName.length > 0 )
                        {
                            $('#epromotorUserFirstName').next().hide();
                        }
                    if( lastName.length > 0 )
                        {
                            $('#epromotorUserLastName').next().hide();
                        }

                    //validation email address format
                    if( emailAddress.length > 0 && !emailRegexp.test(String(emailAddress).toLowerCase()) )
                        {
                            $('#epromotorUserEmail').next().text(config.ppEmailError);
                            $('#epromotorUserEmail').next().show();
                        }
                    else
                        {
                            $('#epromotorUserEmail').next().text('');
                            $('#epromotorUserEmail').next().hide();
                        }

                    if( emailRegexp.test(String(emailAddress).toLowerCase()) && firstName.length > 0 && lastName.length > 0 ){
                        var checkbox = $('#epromotorPrivacyPolicyForm input:checkbox[name=epromotorppChk]');
                        if( checkbox.eq(0).prop('checked') && checkbox.eq(1).prop('checked') ){
                            $submitBtn.removeAttr('disabled');
                        }
                    }
                });
            }
            //LGCOMMON-5306 END

            $('input:checkbox[name=epromotorppChk]').on('click', function(){

                var elIdx = $('input:checkbox[name=epromotorppChk]').index($(this));
                var checkbox = $('#epromotorPrivacyPolicyForm input:checkbox[name=epromotorppChk]');
                var isChecked = $(this).prop('checked');
                var $submitBtn = $('.epromotor-btn.epromotor-btn--base.epromotor-policy-button');

              //필수 checkbox 체크 시 submit button 활성화.
                //LGCOMMON-5306 START
                if(config.fullNameUseFlag == 'Y'){
                	if(checkbox.eq(0).prop('checked')){
                		var fullName = $('#epromotorUserFullName').val();
                		var emailAddress = $('#epromotorUserEmail').val();
                		
                		if(fullName.length < 1){
                            $('#epromotorUserFullName').next().show();
                        }
                        //validation email address format
                        if(!emailRegexp.test(String(emailAddress).toLowerCase())){
                        	$('#epromotorUserEmail').next().show();
                        }else{
                        	$('#epromotorUserEmail').next().hide();
                        }
                        
                        if(fullName.length < 1){
                        	return $('#epromotorUserFullName').focus();
                        }
                        if(!emailRegexp.test(String(emailAddress).toLowerCase())){
                        	return $('#epromotorUserEmail').focus();
                        }
                        
                        $submitBtn.removeAttr('disabled');
	                }else{
	                	$submitBtn.attr('disabled', true);
	                }
                	
                	if(config.ppMktAgreeExtUseFlag == 'Y'){
                		if(checkbox.eq(1).prop('checked')){
    		            	$(".epromotorPromotionCheck_Ext").removeClass('d-none')
    		            }else{
    		            	$(".epromotorPromotionCheck_Ext").addClass('d-none')
    		            }
                	}
                	
                }else{
                    if( checkbox.eq(0).prop('checked') && checkbox.eq(1).prop('checked') )
                        {
	                    	var firstName = $('#epromotorUserFirstName').val();
	                        var lastName = $('#epromotorUserLastName').val();
	                        var emailAddress = $('#epromotorUserEmail').val();
	                        
	                        if( firstName.length < 1 )
	                            {
	                                $('#epromotorUserFirstName').next().show();
	                            }
	                        if( lastName.length < 1 )
	                            {
	                                $('#epromotorUserLastName').next().show();
	                            }

                            //validation email address format
                            if( !emailRegexp.test(String(emailAddress).toLowerCase()) )
                                {
                                    $('#epromotorUserEmail').next().show();
                                }
                            else
                                {
                                    $('#epromotorUserEmail').next().hide();
                                }

                            if( firstName.length < 1 )
	                            {
	                                return $('#epromotorUserFirstName').focus();
	                            }
	                        if( lastName.length < 1 )
	                            {
	                                return $('#epromotorUserLastName').focus();
	                            }
                            if( !emailRegexp.test(String(emailAddress).toLowerCase()) )
                                {
                                    return $('#epromotorUserEmail').focus();
                                }
                            $submitBtn.removeAttr('disabled');
                        }
                    else
                        {
                            $submitBtn.attr('disabled', true);
                        }
                    
                    /* LGEGMC-4243 s */
    				if(checkbox.eq(2).prop('checked')){
		            	$(".epromotorPromotionCheck_Ext").removeClass('d-none')
		            }else{
		            	$(".epromotorPromotionCheck_Ext").addClass('d-none')
		            }
    				/* LGEGMC-4243 e */
                }
                //LGCOMMON-5306 END
            });


            $('.epromotor-btn.epromotor-btn--base.epromotor-policy-button').on('click', function(){
                
                var emailAddress = replaceSpecialCharacter($('#epromotorUserEmail').val());
                var checkboxArr = [];
                var addTagMarketing = ['marketing_disagree'];
                var html = '';
                // LGEPH-308 start
                var phoneNo = '';
                if(config.localeCode == 'PH') phoneNo = $('#epromotorPhone').val();
                // LGEPH-308 end

                //LGCOMMON-5306 START
                if(config.fullNameUseFlag == 'Y'){
                	var fullName = replaceSpecialCharacter($('#epromotorUserFullName').val());
                    
                    if( fullName.length < 1 )
	                    {
	                        $('#epromotorUserFullName').focus();
	                        return $('#epromotorUserFullName').next().show();
	                    }
                }else{
                	var firstName = replaceSpecialCharacter($('#epromotorUserFirstName').val());
                    var lastName = replaceSpecialCharacter($('#epromotorUserLastName').val());
                    
                    if( firstName.length < 1 )
	                    {
	                        $('#epromotorUserFirstName').focus();
	                        return $('#epromotorUserFirstName').next().show();
	                    }
	                if( lastName.length < 1 )
	                    {
	                        $('#epromotorUserLastName').focus();
	                        return $('#epromotorUserLastName').next().show();
	                    }
                }
                //LGCOMMON-5306 END
                
                if( emailAddress.length < 1 )
                    {
                        $('#epromotorUserEmail').focus();
                        return $('#epromotorUserEmail').next().show();
                    }

                //validation email address format
                if( !emailRegexp.test(String(emailAddress).toLowerCase()) )
                    {
                        $('#epromotorUserEmail').focus();
                        return $('#epromotorUserEmail').next().show();
                    }

                $("input:checkbox[id='epromotorPrivacyPolicy']").parent().find('.epromotor-form__alert').hide();

                //필수 체크박스
                if ( $("input:checkbox[id='epromotorPrivacyPolicy']").is(":checked") === false )
                    {
                        $('#epromotorPrivacyPolicy').focus();
                        return $("input:checkbox[id='epromotorPrivacyPolicy']").parent().find('.epromotor-form__alert').show();
                    }

                /* LGCOMMON-5306 START */
                if(config.ppSaveAgreeUseFlag == 'Y'){
                	$("input:checkbox[id='epromotorChatHistory']").parent().find('.epromotor-form__alert').hide();
                	
                	//필수 체크박스
                    if ( $("input:checkbox[id='epromotorChatHistory']").is(":checked") === false )
                        {
                            $('#epromotorChatHistory').focus();
                            return $("input:checkbox[id='epromotorChatHistory']").parent().find('.epromotor-form__alert').show();
                        }
				}
                /* LGCOMMON-5306 END */

                checkboxArr.push(0);
                checkboxArr.push(1);

                $('.epromotor-btn.epromotor-btn--base.epromotor-policy-button').removeAttr('disabled');

                //선택 체크박스
                if ( $("input:checkbox[id='epromotorPromotionCheck']").is(":checked") === true )
                    {
                        addTagMarketing = ['marketing_agree'];
                        checkboxArr.push(2);
                        var checkStr = checkboxArr.join(',');
                        
                        //LGCOMMON-5306 START
                        if(config.fullNameUseFlag == 'Y'){
                        	var visitorInfo = { display_name : fullName, email : emailAddress };
                            if(config.localeCode == 'PH') visitorInfo = { display_name : fullName, email : emailAddress, phone : phoneNo };	//	LGEPH-308 add phone
                        }else{
                        	var visitorInfo = { display_name : firstName + ' ' + lastName, email : emailAddress };
                            if(config.localeCode == 'PH') visitorInfo = { display_name : firstName + ' ' + lastName, email : emailAddress, phone : phoneNo };	//	LGEPH-308 add phone
                        }
                        //LGCOMMON-5306 END
                        
                        var selectedDataJSON = selectedData;
			/* LGEGMC-4243 s */
			if(_dl.isLogin == 'Y' && config.ppEmpUseFlag =='Y'){
                       	 $.ajax({
                                type: 'post',
                                url: '/'+config.localeCode.toLowerCase()+'/mkt/api/epromoter/ppMktAgree',
                                data: {'ppMktAgree':'Y','chkEmailAddr':config.loginEmail},
                                xhrFields: {withCredentials: true},
                                beforeSend: function() {},
                                success: function(data) {
                                   console.log(data);
                                },
                                complete: function(){}
                            });
                        }
			/* LGEGMC-4243 e */
                        sendZChatPPFormSubmit(visitorInfo, addTagMarketing, checkStr, selectedDataJSON);
                    }
                else
                    {
                        //setZChatMktBtn();
                        var checkStr = checkboxArr.join(',');
                        
                        //LGCOMMON-5306 START
                        if(config.fullNameUseFlag == 'Y'){
                        	var visitorInfo = { display_name : fullName, email : emailAddress };
                            if(config.localeCode == 'PH') visitorInfo = { display_name : fullName, email : emailAddress, phone : phoneNo };	//	LGEPH-308 add phone
                        }else{
                        	var visitorInfo = { display_name : firstName + ' ' + lastName, email : emailAddress };
                            if(config.localeCode == 'PH') visitorInfo = { display_name : firstName + ' ' + lastName, email : emailAddress, phone : phoneNo };	//	LGEPH-308 add phone
                        }
                        //LGCOMMON-5306 END
                        
                        var selectedDataJSON = selectedData;

                        sendZChatPPFormSubmit(visitorInfo, addTagMarketing, checkStr, selectedDataJSON);
                    }
            });
        }
    function sendZChatPPFormSubmit(visitorInfo, addTagMarketing, checkStr, selectedDataJSON)
        {
            zChat.setVisitorInfo(visitorInfo, function(err) {
            if( !err )
                {
                    var checkArr = checkStr.split(',');
                    if( $('#epromotorMarketing').prop('checked') && checkArr.indexOf(2) == -1 ) {
                      checkArr.push(2);
                      checkStr = checkArr.join(',');
                      addTagMarketing = ['marketing_agree'];
                    }
                    if(checkArr.indexOf(2) !== -1){
                      addTagMarketing = ['marketing_agree'];
                    }

                    config.ip ? addTagMarketing.push('con_ip_' + config.ip) : '';
                    config.localeCode ? addTagMarketing.push('locale_' + config.localeCode) : '';

                    addTagMarketing.push('pp_agree');
                    addTagMarketing.push('pp_agree_save');

                    zChat.addTags(addTagMarketing, function(err) {
                        if( !err )
                            {
                                zChat.setVisitorDefaultDepartment(globalDepartmentId, function(err) {
                                    zChat.sendChatMsg(startEscapeChar, function(err) {

                                        setZChatCookie(checkStr, 'zchatppchk', 'string');
                                        setZChatCookie(selectedDataJSON, 'zchatdata', 'json');

                                        $('.epromotor-btn.epromotor-btn--base.epromotor-policy-button').attr('disabled', true);
                                        $('#epromotorPrivacyPolicyForm .epromotor-form__alert').hide();
                                        $('#epromotorCommType').show();
                                        setZChatBeforeConn(setZChatUnixToTime(getZChatUnixTime()));
                                        autoScrollStop = false;
                                        setZChatScrollTop();

                                        if($(document).find('.epromotor-category-dom').length > 1 )
                                            {
                                                $.each( $(document).find('.epromotor-category-dom'), function(idx, item){
                                                    $(this).find('button').attr('disabled', true);
                                                });
                                            }

                                        //LGCOMMON-5306 START
                                        if(config.fullNameUseFlag == 'Y'){
                                        	$('#epromotorUserFullName,#epromotorUserEmail').prop('disabled',true);
                                        }else{
                                        	$('#epromotorUserFirstName,#epromotorUserLastName,#epromotorUserEmail').prop('disabled',true);
                                        }
                                        //LGCOMMON-5306 END
                                        if(config.localeCode == 'PH')   $('#epromotorPhone, #epromotorMessage').prop('disabled',true);	// LGEPH-308 add
                                        $('#epromotorPrivacyPolicyForm .epromotor-form').addClass('epromotor-form--disabled');
                                        $('.epromotor-reqrating-dom').remove();

                                        waitingTimeoutIns = setTimeout(function(){setZChatWaitingCmt(false);}, waitingTimeout * 1000);
                                    });
                                    
                                    if(config.localeCode == 'PH') zChat.sendChatMsg(replaceSpecialCharacter($('#epromotorMessage').val()), function(err){})		// LGEPH-308 add
                                });
                            }
                    });
                }
            });
        }
    function setZChatBaseHtml()
        {
            var html = '';
            var desktopClass = window.isMobile ? '' : 'epromotor-container--desktop';
            /* LGEMS-359, LGEMS-378 : drag flag를 사용하며, PC인 경우에만 drag class 부여 */
            if(config.chatbotIframeDragFlag =='Y' && !isMobile() && $(".chat_drag").length < 1){
            	html = '<div class="chat_drag"><div class="chat_bar"></div>'
            }
            /* LGEMS-359 */

            // LGESE-158 Start
            let onlineGreeting2 = config.greeting2;
            if (config.saleMessageFlag == 'Y'){
                onlineGreeting2 += config.saleMessage3 == 'epromoter-lang-sale-message3' ? '' : '<br/><br/>' + config.saleMessage3;
                onlineGreeting2 += config.saleMessage4 == 'epromoter-lang-sale-message4' ? '' : '<p class="sale-desc">' + config.saleMessage4 + '</p>';
            }
            // LGESE-158 End

            html +=  '<div class="epromotor-chat-area">'+
                  '<div class="epromotor-container">'+
                        '<div class="epromotor-header" id="epromotorAccountStatus">'+
                          '<div class="epromotor-header__inner">'+
                            '<div class="epromotor-counselor">'+
                              '<div class="epromotor-counselor__info">'+
                                '<strong class="epromotor-counselor__title">'+
                                  'LG Live Chat'+
                                '</strong>'+
                                '<span class="epromotor-counselor__state" id="epromotorAccountStatusTxt">'+
                                '</span>'+
                              '</div>'+
                            '</div>'+
                            '<div class="epromotor-header__left">'+
                              '<button type="button" class="epromotor-btn epromotor-btn--close" aria-label="close">'+
                                '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">'+
                                  '<g fill="none" fill-rule="evenodd">'+
                                    '<path stroke="#000" stroke-linecap="round" stroke-width="1.5" d="M7 15.5L25.551 15.546" transform="translate(-12.000000, -38.000000) translate(0.000000, 20.000000) translate(12.000000, 18.000000)"/>'+
                                  '</g>'+
                                '</svg>'+
                              '</button>'+
                            '</div>'+
                            '<div class="epromotor-header__right">'+
                              '<button type="button" class="epromotor-btn epromotor-btn--endchat">'+
                                '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">'+
                                  '<g fill="none" fill-rule="evenodd">'+
                                    '<path fill="#000" fill-rule="nonzero" d="M8.67 8.67c.293-.293.767-.293 1.06 0L16 14.939l6.27-6.27c.293-.292.767-.292 1.06 0 .267.267.29.684.073.977l-.073.084L17.061 16l6.27 6.27.072.084c.218.293.194.71-.073.976-.293.293-.767.293-1.06 0L16 17.061l-6.27 6.27c-.293.292-.767.292-1.06 0-.267-.267-.29-.684-.073-.977l.073-.084L14.939 16l-6.27-6.27-.072-.084c-.218-.293-.194-.71.073-.976z"    transform="translate(-276.000000, -38.000000) translate(0.000000, 20.000000) translate(276.000000, 18.000000)"/>'+
                                  '</g>'+
                                '</svg>'+
                              '</button>'+
                            '</div>'+
                          '</div>'+
                        '</div>'+
                        '<div class="epromotor-contents">'+
                          '<div class="epromotor-contents__inner">'+
                            '<div class="epromotor-support" id="epromotorOffline">';
			    if (config.saleMessageFlag == 'Y'){
                            	html += '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--single multiBlock" id="epromoterChatDomDiv">';
                            }else{
                            	html += '<div class="epromotor-chat__message epromotor-chat__message--receive epromotor-chat__message--single" id="epromoterChatDomDiv">';
                            }
                            
                            html += '<div class="epromotor-chat__string epromotor-chat__string--contents" id="epromoterSupportDiv">'+
                                '</div>'+
                                '<div class="epromotor-chat__string epromotor-chat__string--contents" id="epromoterSupportSaleDiv">'+
                                '</div>'+
                              '</div>'+
                            '</div>'+
                            '<div class="epromotor-chat">'+
                              '<div class="epromotor-chat__message epromotor-chat__message--receive">'+
                                '<div class="epromotor-chat__string">'+
                                  config.greeting1 +
                                '</div>'+
                              '</div>'+
                              '<div class="epromotor-chat__message epromotor-chat__message--receive">'+
                                '<div class="epromotor-chat__string">'+
                                  onlineGreeting2 + // LGESE-158
                                '</div>'+
                                '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+
                                '</span>'+
                              '</div>'+
                              '<div class="epromotor-chat__message epromotor-chat__message--receive" id="epromotorPrivacyPolicyForm">'+
                                '<div class="epromotor-chat__string epromotor-chat__string--contents epromotor-form">'+
                                  '<div class="epromotor-chat__string-head">'+
                                    config.ppTitle +
                                  '</div>'+
                                  '<div class="epromotor-chat__string-body">';
                                  /* LGCOMMON-5306 START */
                                  if(config.fullNameUseFlag == 'Y'){
                                	  html +='<p class="epromotor-form__item " style="margin-bottom: 16px;">'+
                                	  	'<label for="epromotorUserFullName" class="epromotor-form__label">' + config.fullName + ' <i>*</i></label>'+
	                              		'<input type="text" class="epromotor-input" id="epromotorUserFullName" placeholder="'+config.fullNameAlert+'" maxlength="30">'+
	                              		'<span class="epromotor-form__alert">' + config.fullNameAlert + '</span>'+
	                              	  '</p>';
                                  }else{
                                	  html +='<p class="epromotor-form__item " style="margin-bottom: 16px;">'+
                                      '<label for="epromotorUserFirstName" class="epromotor-form__label">'+config.ppFname + ' <i>*</i></label>'+
                                      '<input type="text" class="epromotor-input" id="epromotorUserFirstName" placeholder="'+config.ppFnameAlert+'" maxlength="30">'+
                                      '<span class="epromotor-form__alert">'+
                                        config.ppFnameAlert +
                                      '</span>'+
                                    '</p>'+
                                    '<p class="epromotor-form__item " style="margin-bottom: 16px;">'+
                                      '<label for="epromotorUserLastName" class="epromotor-form__label">'+config.ppLname + ' <i>*</i></label>'+
                                      '<input type="text" class="epromotor-input" id="epromotorUserLastName" placeholder="'+config.ppLnameAlert+'" maxlength="30">'+
                                      '<span class="epromotor-form__alert">'+
                                        config.ppLnameAlert +
                                      '</span>'+
                                    '</p>';
                                  }
                                  /* LGCOMMON-5306 END */
                                  	html +='<p class="epromotor-form__item " style="margin-bottom: 19px;">'+
                                      '<label for="epromotorUserEmail" class="epromotor-form__label">'+config.ppEmail + ' <i>*</i></label>'+
                                      '<input type="email" class="epromotor-input" id="epromotorUserEmail" placeholder="'+config.ppEmailAlert+'" maxlength="60">'+
                                      '<span class="epromotor-form__alert">'+
                                        config.ppEmailAlert +
                                      '</span>'+
                                    '</p>'+
                                    /* LGEPH-308 start */
                                    '';
                                    if(config.localeCode == 'PH'){
                                    html +='<p class="epromotor-form__item " style="margin-bottom: 16px;">'+
                                      '<label for="epromotorPhone" class="epromotor-form__label">'+ config.ppPhone +'</label>'+
                                      '<input type="text" class="epromotor-input" id="epromotorPhone" maxlength="40" oninput="this.value = this.value.replace(/[^0-9-]/g, \'\');">'+
                                    '</p>'+	
                                    '<p class="epromotor-form__item " style="margin-bottom: 19px;">'+
                                      '<label for="epromotorMessage" class="epromotor-form__label">'+ config.ppMessage +'</label>'+
                                      '<input type="text" class="epromotor-input" id="epromotorMessage" maxlength="4000">'+
                                    '</p>';
                                    }
                                    html +=''+
                            		/* LGEPH-308 end */
                                    '<p class="epromotor-form__item ">'+
                                      '<label for="epromotorPrivacyPolicy" class="epromotor-form__label-checkbox">'+
                                        '<input type="checkbox" class="epromotor-form__checkbox" id="epromotorPrivacyPolicy" name="epromotorppChk">'+
                                        '<span class="epromotor-form__label-inner">'+
                                          config.ppAgree1 + ' <a href="'+config.ppUrl+'" class="epromotor-form__label-link" target="_blank">'+config.ppAgree2+'</a> <i>*</i>'+
                                        '</span>'+
                                        '<span class="epromotor-form__alert">'+config.ppAgreeAlert+'</span>'+
                                      '</label>'+
                                    '</p>'
                                    /* LGCOMMON-5306 START */
                                    if(config.ppSaveAgreeUseFlag == 'Y'){
	                                    html +='<p class="epromotor-form__item ">'+
	                                      '<label for="epromotorChatHistory" class="epromotor-form__label-checkbox">'+
	                                        '<input type="checkbox" class="epromotor-form__checkbox" id="epromotorChatHistory" name="epromotorppChk">'+
	                                        '<span class="epromotor-form__label-inner">'+config.ppSaveAgree + '<i>*</i>'+'</span>'+
	                                        '<span class="epromotor-form__alert">'+config.ppAgreeSaveAlert+'</span>'+
	                                      '</label>'+
	                                    '</p>';
                                    }
                                    /* LGCOMMON-5306 END */
		                            if(config.ppMktAgreeFlag !='Y'){
		                            html += '<p class="epromotor-form__item ">'+
	                                      '<label for="epromotorPromotionCheck" class="epromotor-form__label-checkbox">'+
	                                        '<input type="checkbox" class="epromotor-form__checkbox" id="epromotorPromotionCheck" name="epromotorppChk">'+
	                                        '<span class="epromotor-form__label-inner">'+
	                                           config.ppMktAgree + '<br><br>';
	                                           if(config.ppEmpUseFlag =='Y' && config.ppMktAgreeExtUseFlag == 'Y'){
	                                        	   html += '<span class="epromotorPromotionCheck_Ext d-none">'+config.ppMktAgreeExt+'<br/></span>';
	                                           }
	                                           html += '</span>'+
	                                           		'</label>'+
                                           		'</p>';
		                            }
		                            html += '<p style="margin-bottom: 18px;">'+
	                                    '<label style="padding-left: 26px;>'+
	                                      '<span class="epromotor-form__label-inner">'+
	                                        '<i style="color:#a50034">*</i> '+ config.ppRequiredFields +
	                                      '</span>'+
	                                    '</label>'+
	                                  '</p>';
                                   	html += '<button type="button" class="epromotor-btn epromotor-btn--base epromotor-policy-button" disabled>'+
                                      config.btnSubmit+
                                    '</button>'+
                                  '</div>'+
                                '</div>'+
                                '<span class="epromotor-chat__time" name="epromotorDefualtChatTime">'+
                                '</span>'+
                              '</div>'+
                              '<div class="epromotor-chat__message epromotor-chat__message--receive" name="epromotorStarRatingForm" id="epromotorStarRatingForm" style="display:none">'+
                                '<div class="epromotor-chat__string epromotor-form">'+
                                  '<div class="epromotor-chat__string-head">'+ config.feedbackHeader+'</div>'+
                                  '<div class="epromotor-chat__string-body">'+
                                    '<div class="epromotor-star" data-star-value="0" id="epromotorStarUi">'+
                                      '<div class="epromotor-star__display">'+
                                        '<span class="epromotor-star__item">'+
                                          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'+
                                            '<g fill="none" fill-rule="evenodd">'+
                                              '<g fill-rule="nonzero" stroke="#A50034">'+
                                                '<path d="M12.001 1.5c.093 0 .186.024.267.075h0l3.155 6.228 6.65.972c.099.015.183.053.25.11.073.061.125.142.154.23.028.09.034.185.011.278-.021.085-.067.166-.138.235h0l-4.812 4.687 1.136 6.62c.017.098.006.191-.027.272-.036.089-.097.163-.172.218-.075.054-.165.09-.26.096-.087.006-.179-.012-.267-.058h0l-5.947-3.128-5.947 3.128c-.088.046-.18.064-.267.058-.095-.007-.185-.042-.26-.096-.075-.055-.136-.13-.172-.218-.033-.081-.044-.174-.027-.272h0l1.136-6.62-4.812-4.687c-.07-.07-.117-.15-.138-.235-.023-.093-.017-.189.011-.277.03-.089.081-.17.154-.231.067-.057.151-.095.25-.11h0l6.65-.972 2.974-6.024c.044-.09.107-.158.181-.204.081-.05.174-.075.267-.075z" transform="translate(-50.000000, -190.000000) translate(0.000000, 20.000000) translate(17.000000, 88.000000) translate(33.000000, 82.000000)"/>'+
                                              '</g>'+
                                            '</g>'+
                                          '</svg>'+
                                        '</span>'+
                                        '<span class="epromotor-star__item">'+
                                          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'+
                                            '<g fill="none" fill-rule="evenodd">'+
                                              '<g fill-rule="nonzero" stroke="#A50034">'+
                                                '<path d="M12.001 1.5c.093 0 .186.024.267.075h0l3.155 6.228 6.65.972c.099.015.183.053.25.11.073.061.125.142.154.23.028.09.034.185.011.278-.021.085-.067.166-.138.235h0l-4.812 4.687 1.136 6.62c.017.098.006.191-.027.272-.036.089-.097.163-.172.218-.075.054-.165.09-.26.096-.087.006-.179-.012-.267-.058h0l-5.947-3.128-5.947 3.128c-.088.046-.18.064-.267.058-.095-.007-.185-.042-.26-.096-.075-.055-.136-.13-.172-.218-.033-.081-.044-.174-.027-.272h0l1.136-6.62-4.812-4.687c-.07-.07-.117-.15-.138-.235-.023-.093-.017-.189.011-.277.03-.089.081-.17.154-.231.067-.057.151-.095.25-.11h0l6.65-.972 2.974-6.024c.044-.09.107-.158.181-.204.081-.05.174-.075.267-.075z" transform="translate(-50.000000, -190.000000) translate(0.000000, 20.000000) translate(17.000000, 88.000000) translate(33.000000, 82.000000)"/>'+
                                              '</g>'+
                                            '</g>'+
                                          '</svg>'+
                                        '</span>'+
                                        '<span class="epromotor-star__item">'+
                                          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'+
                                            '<g fill="none" fill-rule="evenodd">'+
                                              '<g fill-rule="nonzero" stroke="#A50034">'+
                                                '<path d="M12.001 1.5c.093 0 .186.024.267.075h0l3.155 6.228 6.65.972c.099.015.183.053.25.11.073.061.125.142.154.23.028.09.034.185.011.278-.021.085-.067.166-.138.235h0l-4.812 4.687 1.136 6.62c.017.098.006.191-.027.272-.036.089-.097.163-.172.218-.075.054-.165.09-.26.096-.087.006-.179-.012-.267-.058h0l-5.947-3.128-5.947 3.128c-.088.046-.18.064-.267.058-.095-.007-.185-.042-.26-.096-.075-.055-.136-.13-.172-.218-.033-.081-.044-.174-.027-.272h0l1.136-6.62-4.812-4.687c-.07-.07-.117-.15-.138-.235-.023-.093-.017-.189.011-.277.03-.089.081-.17.154-.231.067-.057.151-.095.25-.11h0l6.65-.972 2.974-6.024c.044-.09.107-.158.181-.204.081-.05.174-.075.267-.075z" transform="translate(-50.000000, -190.000000) translate(0.000000, 20.000000) translate(17.000000, 88.000000) translate(33.000000, 82.000000)"/>'+
                                              '</g>'+
                                            '</g>'+
                                          '</svg>'+
                                        '</span>'+
                                        '<span class="epromotor-star__item">'+
                                          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'+
                                            '<g fill="none" fill-rule="evenodd">'+
                                              '<g fill-rule="nonzero" stroke="#A50034">'+
                                                '<path d="M12.001 1.5c.093 0 .186.024.267.075h0l3.155 6.228 6.65.972c.099.015.183.053.25.11.073.061.125.142.154.23.028.09.034.185.011.278-.021.085-.067.166-.138.235h0l-4.812 4.687 1.136 6.62c.017.098.006.191-.027.272-.036.089-.097.163-.172.218-.075.054-.165.09-.26.096-.087.006-.179-.012-.267-.058h0l-5.947-3.128-5.947 3.128c-.088.046-.18.064-.267.058-.095-.007-.185-.042-.26-.096-.075-.055-.136-.13-.172-.218-.033-.081-.044-.174-.027-.272h0l1.136-6.62-4.812-4.687c-.07-.07-.117-.15-.138-.235-.023-.093-.017-.189.011-.277.03-.089.081-.17.154-.231.067-.057.151-.095.25-.11h0l6.65-.972 2.974-6.024c.044-.09.107-.158.181-.204.081-.05.174-.075.267-.075z" transform="translate(-50.000000, -190.000000) translate(0.000000, 20.000000) translate(17.000000, 88.000000) translate(33.000000, 82.000000)"/>'+
                                              '</g>'+
                                            '</g>'+
                                          '</svg>'+
                                        '</span>'+
                                        '<span class="epromotor-star__item">'+
                                          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'+
                                            '<g fill="none" fill-rule="evenodd">'+
                                              '<g fill-rule="nonzero" stroke="#A50034">'+
                                                '<path d="M12.001 1.5c.093 0 .186.024.267.075h0l3.155 6.228 6.65.972c.099.015.183.053.25.11.073.061.125.142.154.23.028.09.034.185.011.278-.021.085-.067.166-.138.235h0l-4.812 4.687 1.136 6.62c.017.098.006.191-.027.272-.036.089-.097.163-.172.218-.075.054-.165.09-.26.096-.087.006-.179-.012-.267-.058h0l-5.947-3.128-5.947 3.128c-.088.046-.18.064-.267.058-.095-.007-.185-.042-.26-.096-.075-.055-.136-.13-.172-.218-.033-.081-.044-.174-.027-.272h0l1.136-6.62-4.812-4.687c-.07-.07-.117-.15-.138-.235-.023-.093-.017-.189.011-.277.03-.089.081-.17.154-.231.067-.057.151-.095.25-.11h0l6.65-.972 2.974-6.024c.044-.09.107-.158.181-.204.081-.05.174-.075.267-.075z" transform="translate(-50.000000, -190.000000) translate(0.000000, 20.000000) translate(17.000000, 88.000000) translate(33.000000, 82.000000)"/>'+
                                              '</g>'+
                                            '</g>'+
                                          '</svg>'+
                                        '</span>'+
                                      '</div>'+
                                      '<input type="range" class="epromotor-star__range" min="1" max="5" step="1" value="1">'+
                                    '</div>'+
                                    '<p class="epromotor-form__item" style="margin-bottom: 17px;">'+
                                      '<textarea name="" id="epromotorChatTextarea" class="epromotor-form-textarea" placeholder="'+config.feedbackCmt+'" disabled></textarea>'+
                                    '</p>'+
                                    '<p class="epromotor-form__item">'+
                                      '<button class="epromotor-btn epromotor-btn--base" id="epromotorReqRatingSubmit" disabled>'+
                                        config.btnSubmit +
                                      '</button>'+
                                    '</p>'+
                                  '</div>'+
                                '</div>'+
                                '<span class="epromotor-chat__time" id="epromotorReqRatingTime">'+
                                '</span>'+
                              '</div>'+
                            '</div>'+
                          '</div>'+
                        '</div>'+
                        '<div class="epromotor-bottom">'+
                          '<div class="epromotor-bottom__inner">'+
                            '<div class="epromotor-bottom__field">'+
                              '<label  for="epromotorSendFile"  class="epromotor-btn epromotor-btn--file">'+
                                '<input type="file"  id="epromotorSendFile" aria-label="select my file" disabled />'+
                                '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">'+
                                  '<g fill="none" fill-rule="evenodd">'+
                                    '<g transform="translate(-23.000000, -162.000000) translate(15.000000, 156.000000) translate(8.000000, 6.000000)">'+
                                      '<path fill="#8E8E8E" fill-rule="nonzero" d="M15.266 6.065l-7.64 7.437c-2.52 2.506-2.498 6.521.05 9.001 2.564 2.495 6.72 2.495 9.284 0l6.21-6.043c.281-.274.281-.72 0-.994-.278-.27-.725-.27-1.003 0l-6.21 6.044c-2.01 1.955-5.269 1.955-7.278 0-2.005-1.952-2.005-5.113 0-7.065l7.59-7.386c1.247-1.214 3.271-1.214 4.518 0 1.243 1.21 1.243 3.168 0 4.378l-7.59 7.387c-.485.471-1.273.471-1.758 0-.48-.468-.48-1.225 0-1.693l7.59-7.386c.282-.274.282-.72 0-.994-.277-.27-.725-.27-1.002 0l-7.59 7.387c-1.044 1.015-1.044 2.664 0 3.679l.13.119c.935.797 2.309.851 3.302.154l.146-.111.011.007 7.764-7.555c1.806-1.757 1.806-4.609 0-6.366-1.802-1.753-4.721-1.753-6.524 0z" />'+
                                    '</g>'+
                                  '</g>'+
                                '</svg>'+
                              '</label>'+
                              '<textarea name="" id="epromotorTextArea" class="epromotor-bottom-textarea" data-auto-height="true" placeholder="'+config.typeYourMessage+'" disabled></textarea>'+
                              '<button type="button" class="epromotor-btn epromotor-btn--send" aria-label="send message" disabled>'+
                                '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">'+
                                '<g fill="none" fill-rule="evenodd" stroke-linejoin="round">'+
                                  '<g fill="#A50034" stroke="#A50034">'+
                                    '<path d="M16 4.847l10.947 22.737-9.364-2.882-.837-10.66c-.014-.18-.092-.342-.21-.463-.662-.217-.857-.157-1.004-.047h0l-1.116 11.171-9.363 2.88L16 4.848z" transform="translate(-268.000000, -517.000000) translate(15.000000, 512.000000) translate(253.000000, 5.000000) translate(16.000000, 16.384615) rotate(90.000000) translate(-16.000000, -16.384615)"></path>'+
                                  '</g>'+
                                '</g>'+
                              '</svg>'+
                              '</button>'+
                            '</div>'+
                          '</div>'+
                        '</div>'+
                      '</div>'+
                    '</div>';
                /* LGEMS-359, LGEMS-378 */          
                if(config.chatbotIframeDragFlag =='Y' && !isMobile()){
                	html += '</div>'
                }/* LGEMS-359, LGEMS-378 */
                    /*'<div class="epromotor-dimd"></div>';*/
            var $html = $(html);

            $html.appendTo('body');
        }

    function setZChatWidgetHtml()
        {
    		//LGCOMMON-5394 Start
    		var epromoterImprovedIconUse = config.epromoterImprovedIconUse;
    		var widgetClass = '<div class="epromotor-widget-area ready active">';
    		var widgetImage = '/lg5-common-gp/images/customer/ic-livechat-01.svg';
    		
    		if(epromoterImprovedIconUse == "Y"){
    			widgetClass = '<div class="epromotor-widget-area color-carmine ready active">';
        		widgetImage = '/lg5-common-gp/images/customer/ic-livechat-01-carmine.svg';
    		}
    		
            var html = '';

            html =  widgetClass+
                  '<div class="epromotor-widget-position">'+
                    '<div class="epromotor-widget">'+
                      '<span class="epromotor-widget__counter" style="opacity: 0;"></span>'+ // LGCOMMON-4570
                      '<button class="epromotor-widget__button">'+
                        '<span class="epromotor-widget__inner">'+
                          '<span class="epromotor-widget__image">'+
                            '<img src="' + widgetImage + '" alt="" width="34" height="34">'+
                          '</span>'+
                          '<span class="epromotor-widget__text">' + config.widgetTitle + '</span>'+
                        '</span>'+
                      '</button>'+
                      '<div class="epromotor-widget__message" style="opacity: 0;">'+ // LGCOMMON-4570
                        '<div class="epromotor-widget__message-wrap">'+
                          '<div class="epromotor-widget__message-inner">'+
                            'Hi, do you need product advice or hlep choosing something?'+
                          '</div>'+
                        '</div>'+
                        '<button class="epromotor-btn">'+
                          '<img src="/lg5-common-gp/images/customer/btn-msg-close-nor.svg" width="22" height="22" alt="">'+
                        '</button>'+
                      '</div>'+
                    '</div>'+
                '</div>'+
              '</div>';
            /* LGCOMPH-26 start */
            //LGCOMMON-5394 End
            if($('.gnb-newChatbotInfo').length == 0 && !!config.langEyeCatchingMessageFlag && config.langEyeCatchingMessageFlag =='Y' && !!!$.cookie('chat_text_layer_PH')){
            	html +=
            	'<div class="chat-msg ready">' +
        			'<div id="chat-msg1" class="chat-msg-area" role="alert" aria-live="assertive"></div>' +
	        		'<div id="epromotorMsg1" class="epromotor-msg active" role="alert" aria-live="assertive">' +
	        			'<div class="epromotor-msg-box">' + config.langEyeCatchingMessage + '</div>' +
	        			'<button class="epromotor-msg-close"><span class="sr-only">close</span></button>' +
	        		'</div>' +
	        	'</div>';
            }
            /* LGCOMPH-26 end */
            var $html = $(html);
	    
            $html.appendTo('body');

            $html.find('.epromotor-widget').on('click', function(){
                getZChatChatbotWidget('widgetBtn');
                if ($(".chat_drag").hasClass('shrink') == true) {
                    $( ".chat_drag" ).removeClass("shrink")
                }
                if ($(".chat_drag").hasClass('ui-draggable') == false) {
                    $( ".chat_drag" ).draggable({ handle: ".chat_bar" , containment: "body"});
                }
            });

            $(document).on('scroll', function(){
                $('.epromotor-widget').addClass('epromotor-widget--intro');
            });

            if( config.chatbotUseYn == 'Y' ){
                 function receiveMessage(e) {
                    var urlArr = config.chatbotUrl.split('/');
                    var chatbotDomain = urlArr[0] + '//' + urlArr[2];
                    if( e.origin != chatbotDomain ){return;}

                    if( e.data ){
                        if( e.data == chatbotCloseMsg ){
                            setZChatEndChatProc();
                            $('#epromoter-chatbot-iframe').remove();
                            $('.iframe_type').remove();
                            $('.epromotor-chat-area ').removeClass('ready active');
                            $('.epromotor-widget-area').addClass('ready active');
                        }else if(e.data =='lg-epromotor-active'){ //LGEMS-420
                        	setZChatEndChatProc();
                            $('#epromoter-chatbot-iframe').remove();
                            $('.iframe_type').remove();
                            $('.epromotor-chat-area').addClass('ready active');
                            $('.epromotor-widget-area').removeClass('ready active');
                        }
                    }
                }
                window.addEventListener("message", receiveMessage, false);
            }
            /* LGCOMPH-26 start */
        	$('.epromotor-msg-close').on('click', function(){
        		$.cookie('chat_text_layer_PH', 'disabled', { path: '/' });
        		$(this).parent('.epromotor-msg').removeClass('active');
        	});
            /* LGCOMPH-26 end */
        }

    function setZChatGlobalVar(data)
        {
            var dPrefix = '^' + data.departmentPrefix;
            var dVPrefix = '^' + data.departmentVideoPrefix;
            var sPrefix = data.snapcallPrefix;
            headerTimeoutToggle = data.headerToggleTimeout;
            startEscapeChar = data.startChar;
            departmentRegexp = new RegExp(dPrefix, 'gi');
            departmentVideoRegexp = new RegExp(dVPrefix, 'gi');
            snapCallUrlRegexp = new RegExp(sPrefix, 'gi');
            alertTimeout = isNaN(parseInt(data.alertTimeout)) ? 4 : parseInt(data.alertTimeout);
            waitingTimeout = isNaN(parseInt(data.waitTimeout)) ? 180 : parseInt(data.waitTimeout);
            waitTimeoutSec180 = isNaN(parseInt(data.waitTimeoutSec180)) ? 99999 : parseInt(data.waitTimeoutSec180);
            waitTimeoutSec360 = isNaN(parseInt(data.waitTimeoutSec360)) ? 99999 : parseInt(data.waitTimeoutSec360);
            channelType = data.chatChannelType.split(',');
            appkey = data.appKey;
            loadedWidget = false;
            tagsArr.push('con_ip_'+config.ip);
            tagsArr.push('locale_'+config.localeCode);
        }
    function getZChatConfig()
        {
            var urlArr = window.location.href.replace(/http(s?):\/\//i,'').split('/');
            var url = '/' + urlArr[1].split('?')[0] + '/mkt/api/epromoter/cfgInfo';			//LGCOMCZ-268 호출에 필요한 국가코드만 들고 오도록 수정
            $.ajax({
                type: 'post',
                url: url,
                data: {},
                dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: function() {},
                success: function(data) {
                    if( data.data.length > 0 && data.status == 'success' ){

                        $('head').append('<link href="/lg5-common-gp/css/epromoter-ui.min.css" type="text/css" rel="stylesheet">');

                        config = data.data[0];
                        if( config.epromoterUseYn == 'Y' ){
                            setZChatBaseHtml();
                            setZChatWidgetHtml();
                            setZChatGlobalVar(config);
                            setZChatInstanceInit();	//LGCOMNL-133 setZChatSupportHtml에서 zdesk 관련 api를 사용해야되서 실행 순서를 바꿈
                            setZChatSupportSaleHtml();//LGESE-118
                            setZChatSupportHtml();
                            

                            // /cac_en/support/chat-email Iniciar chat 버튼 epromoter로 연동.
                            $.each($('div.inner dl.inbox a.btn.btn-primary'), function(idx, item){
                                if( $(item).attr('onclick') == 'open_chat()' )
                                    {
                                        $(item).unbind('click');
                                        $(item).removeAttr('onclick');

                                        $(item).on('click', function(){
                                            if( $('.epromotor-widget-area').hasClass('active') ){
                                                $('.epromotor-widget-area').removeClass('ready active');
                                                $('.epromotor-chat-area').addClass('ready active');
                                            }else{
                                                $('.epromotor-widget-area').addClass('ready active');
                                                $('.epromotor-chat-area').removeClass('ready active');
                                            }
                                        });
                                    }
                            });
                            // /cac_en/support/contactus chat icon epromoter로 연동.
                            $.each($('div.contact-us-link-menu .menu-linkbox-belt .menu-linkbox a'), function(idx, item){
                                if( $(item).attr('onclick') == 'open_chat()' )
                                    {
                                        $(item).unbind('click');
                                        $(item).removeAttr('onclick');

                                        $(item).on('click', function(){
                                            if( $('.epromotor-widget-area').hasClass('active') ){
                                                $('.epromotor-widget-area').removeClass('ready active');
                                                $('.epromotor-chat-area').addClass('ready active');
                                            }else{
                                                $('.epromotor-widget-area').addClass('ready active');
                                                $('.epromotor-chat-area').removeClass('ready active');
                                            }
                                        });
                                    }
                            });

                            // LGEITF-967
                            //FR
                            //LGCOMHU-65	showIPMWidget => activate로 변경
                            if( $('#zendesk-button').attr('onclick') == 'window.zE.activate()' )
                            {
                            	$('#zendesk-button').unbind('click');
                                $('#zendesk-button').removeAttr('onclick');

                                $('#zendesk-button').on('click', function(){
                                	if(config.localeCode == 'FR'){
                                		$(".epromotor-widget-area .epromotor-widget__button").click();
                                	}else{
                                        if( $('.epromotor-widget-area').hasClass('active') ){
                                            $('.epromotor-widget-area').removeClass('ready active');
                                            $('.epromotor-chat-area').addClass('ready active');
                                        }else{
                                            $('.epromotor-widget-area').addClass('ready active');
                                            $('.epromotor-chat-area').removeClass('ready active');
                                        }
                                	}
                                });
                            }
                        }
                    }
                },
                complete: function(){}
            });
        }

    function getZChatLinkInfo(link_url, htmlObj, timestamp)
        {
            var urlArr = window.location.href.replace(/http(s?):\/\//i,'').split('/');
            var apiUrl = '/' + urlArr[1] + '/mkt/api/epromoter/linkInfo';
            $.ajax({
                type: 'post',
                url: apiUrl,
                data: {'url':link_url},
                dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: function() {},
                success: function(data) {
                    if( data.data.length > 0 && data.status == 'success' ){
                        var linkInfo = data.data[0];
                        linkInfo['url'] = link_url;
                        setZChatLinkInfo(linkInfo, htmlObj, timestamp);
                    }
                },
                complete: function(){}
            });
        }

    // LGEITF-594 Start
    function replaceSpecialCharacter(char)
        {
            char = char.replace(/</g,'&lt;');
            char = char.replace(/>/g,'&gt;');
            char = char.replace(/\"/g,'&quot;');
            char = char.replace(/\'/g,'&#39;');
            char = char.replace(/\n$/g,'');		//LGCOMITF-176
            return char;
        }
    // LGEITF-594 End

    // LGEMS-378 START
    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    // LGEMS-378 END

    getZChatConfig();
    
    //LGCOMNL-133 Start
	function getZChatDepartemntsWorkingHour(){
		var allGroupArr = zChat.getAllDepartments();
		var allGroupOperatingHours = zChat.getOperatingHours();
		var localeGroupDepartmentIdArr = [];
		var workingHourFlag = 'N';
		
		for(var i=0; i < allGroupArr.length; i++ ){
			var localeGroupData = allGroupArr[i]; 
            if( localeGroupData.name.match(departmentRegexp) ){
            	localeGroupDepartmentIdArr.push(localeGroupData.id);
            }
        }
		
		for(var i=0; i < localeGroupDepartmentIdArr.length; i++ ){
			var opHour = allGroupOperatingHours.department_schedule[localeGroupDepartmentIdArr[i]];
			var nowDate = new Date();
			var departmentOpHour = opHour[nowDate.getUTCDay()];
			
			for(var j=0; j < departmentOpHour.length; j++ ){
				var startTime = departmentOpHour[j].start;
				var endTime = departmentOpHour[j].end;
				var nowTime = (nowDate.getUTCHours() * 60) + nowDate.getUTCMinutes();
				
				if(startTime <= nowTime && endTime >= nowTime){
					workingHourFlag = 'Y';
					break;
				}
			}
			
			if(workingHourFlag == 'Y'){
				break;
			}
        }
		return workingHourFlag;
	}
	//LGCOMNL-133 End
	
  }); 

	
	
window.addEventListener('message', function(e) {
  if(e.data.hideChatbot === 'hide'){
	hideChatbotWidget = true;
    $('.epromotor-chatbot-area').removeClass('ready active');
    $('.epromotor-widget-area').addClass('ready active');
  }
  
});